(function() {
  "use strict";

  angular.module("sempraWebapp").constant("frTranslations", {
    MESSAGE:"Message",
    ERROR_TITLE:"Erreur",
    ERROR_MESSAGE:"Une erreur lors d'exécution de l'opération est survenue.",
    ERROR_LOGIN:"Erreur de connexion. L'adresse e-mail ou le mot de passe incorrect. Veuillez réessayer.",
    ERROR_LOGIN_ROLE:"Ce rôle n'est pas valide pour la marque actuelle de l'application.",
    OK:"OK",
    CANCEL:"Annuler",
    YES:"Oui",
    NO:"Non",
    FROM:"Du",
    TO:"Jusqu'au",
    DELETE:"Supprimer",
    SIGN_OUT:"Se déconnecter",
    NAME:"Prénom",
    DATE:"Date",
    PIECES:"Pièces",
    HOURS:"Heures",
    DAYS:"Jours",
    MONTH:"Mois",
    MONTHS:"Mois",
    YEAR:"An",
    BOX:"Piste de lavage",
    SEARCH:"Rechercher",
    ALL_USERS:"Tous les utilisateurs",
    ARE_YOU_SURE:"Êtes-vous sûr(e)?",
    BACK:"Retour",
    AMOUNT:"Nombre",
    DESCRIPTION:"La description",
    FORGOT_PASSWORD_ERROR_MSG:"Une erreur s'est produite. Merci de vérifier votre adresse e-mail et réessayer",
    REQUIRED_FIELD:"Champ obligatoire",
    LOGOUT_TITLE:"Êtes-vous sûr(e) de vouloir vous déconnecter ?",
    LOGOUT_MSG:"Tous les modifications des données qui ne sont pas sauvegardées seront supprimées",
    ACTIVATION_ACCOUNT:"Le compte activé avec succès",
    UNKNOWN_ERRROR_NOTIFICATION:"Une erreur inconnue est sourvenue",
    CONTINUE:"Continuer",
    DATA_NOT_AVAILABLE:"Données introuvables",
    SELECT:"Sélectionnez",
    SELECT_CURRENCY:"Sélectionnez la devise",
    UPLOAD:"Envoyer",
    PHONE:"Téléphone",
    WEBSITE:"Site web",
    WORKING_HOURS:"Horaires d'ouverture",
    INSERT:"Insérer",
    TEXT:"Texte",
    CREATED:"Créé",
    VALID_UNTIL:"Valable jusqu'au",
    SAVE:"Sauvegarder",
    TOKENS:"Jetons",
    DELETE_COMPANY_HISTORY:"Supprimer l'historique de la société?",
    DELETE_COMPANY_HISTORY_MESSAGE:"ATTENTION : Une fois que vous appuyez sur ce bouton toutes les transactions de votre station de lavage seront supprimées ! Si ces données sont supprimées, elles ne peuvent pas être récupérées.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Etes-vous sûr(e) de vouloir supprimer toutes les données de transaction ?",
    HISTORY_SUCCESSFULY_DELETED:"Histoire supprimée avec succès",
    HELP:"Aide",
    VALUE:"Valeur",
    ACTIVATING_ACCOUNT_ERROR:"Une erreur est survenue lors de l'activation de votre compte R2W.Veuillez réessayer et si le problème persiste veuillez contacter support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Bienvenue à Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Bienvenu à R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Veuillez saisir et confirmer votre mot de passe pour activer votre compte R2W. Vous serez automatiquement connecté après avoir saisi correctement le mot de passe ",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Vous pouvez modifier les paramètres de l'application plus tard",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Station de lavage Kärcher",
    RESET_PASSWORD_WELCOME_MSG:"Station de lavage R2W",
    RESET_PASSWORD_WELCOME_MSG_2:"Veuillez saisir votre nouveau mot de passe et le confirmer pour réinitialiser l'ancien. Ensuite, vous serez automatiquement connecté(e) à l'application.",
    RESET_PASSWORD_WELCOME_MSG_3:"Vous pourrez ensuite changer les paramètres d'utilisation dans l'application.",
    ENTER_NEW_PASSWORD:"Introduisez le nouveau mot de passe",
    REPEAT_NEW_PASSWORD:"Confirmez votre nouveau mot de passe",
    PASSWORD_MIN_LENGTH:"Le mot de passe doit contenir au moins 8 caractères",
    PASSWORD_MAX_LENGHT:"Le mot de passe ne peut pas contenir plus de 32 caractères",
    PASSWORD_PATTERN:"Le mot de passe doit contenir au moins une lettre en majuscule et une lettre en miniscule",
    PASSWORD_MATCH:"Les mots de passe ne correspondent pas",
    ACTIVATE:"Activer",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Votre demande a été soumise avec succès. S'il vous plaît vérifiez votre email pour le message de confirmation",
    VALIDATION_REQUIRED:"Champ obligatoire",
    VALIDATION_EMAIL:"L'adresse e-mail n'est pas valide",
    VALIDATION_INTEGER_NUMBER:"La valeur saisie doit être un numéro entier",
    VALIDATION_HOURS_VALUE:"La valeur saisie doit être entre 0-23",
    VALIDATION_MINUTES_VALUE:"La valeur saisie doit être entre 0-59",
    VALIDATION_NOT_A_DATE:"La valeur saisie n'est pas une date",
    VALIDATION_FROM:"La date saisie est supérieure à la date de fin",
    VALIDATION_TO:"La date saisie est inférieure à la date de début",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Cette donnée est déjà dans la base de données",
    PASSWORD_VALIDATION_PATTERN_NEW:"Le mot de passe doit contenir au moins une lettre en majuscule, une en minuscule et un chiffre. L'espace vide n'est pas accepté.",
    VALIDATION_PERCENT_VALUE:"La valeur saisie doit être entre 1-999",
    NUMBERS_ONLY_100:"Nombre jusqu'à 100",
    NUMBERS_ONLY_1000:"Nombre jusqu'à 1000",
    POSITIVE_NUMBERS_ONLY:"Seul nombre positif",
    GRID_PAGER_PAGE:"Page",
    GRID_PAGER_ROWS_PER_PAGE:"Lignes par page",
    GRID_PAGER_PAGE_OF:"à partir de",
    BREAD_CRUMBS_HOME:"Page d'accueil",
    BREAD_CRUMBS_DASHBOARD_TECH:"Liste des stations de lavage",
    BREAD_CRUMBS_DETAILS:"Détails",
    BREAD_CRUMBS_SETTINGS:"Paramètres",
    BREAD_CRUMBS_WORKING_HOURS:"Horaires d'ouverture",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Dépenses totales par jours",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Dépenses moyennes par heure",
    BREAD_CRUMBS_NEW_USER_GROUP:"Créer un groupe d'utilisateurs",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Modifier le groupe d'utilisateurs",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Créer un modèle de promotion",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Modifier le modèle de promotion",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Créer une promotion",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Modifer la promotion",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Rapport financier pour la période",
    LOGIN:"Connexion",
    EMAIL:"E-mail",
    PASSWORD:"Mot de passe",
    LANGUAGE:"Langue",
    FORGOT_PASSWORD:"Mot de passe oublié?",
    SUBMIT:"Confirmer",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Nombre d'alarmes actives",
    HEADER_VIEW_ALL_ALARMS:"Toutes les alarmes...",
    HEADER_MY_ACCOUNT:"Mon compte",
    HEADER_ACCOUNT_MANAGEMENT:"Gestion des comptes",
    ACCOUNT_ALREADY_EXIST:"Cette adresse e-mail est déjà utilisée",
    NEWSLETTER_CONFIRMATION:"Envoyer une notification par mail pour l'état des alarmes",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Rapport financier par jour",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Liste des stations de lavage",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Tableau de bord",
    ASIDE_MENU_ALARMS:"Messages",
    ASIDE_MENU_FACILITIES:"Stations de lavage",
    ASIDE_MENU_REPORTS:"Rapports",
    ASIDE_MENU_REPORT:"Rapport sélectionné",
    ASIDE_MENU_LOYALTY:"Promotions",
    ASIDE_MENU_USER_GROUPS:"Groupes d'utilisateurs",
    ASIDE_MENU_PERIODIC_SUMMARY:"Rapport financier ",
    ASIDE_MENU_MANAGING_TOKENS:"Gestion de jetons",
    ASIDE_MENU_NEWS:"Nouvelles",
    DAILY_FINANCES_TOTAL_MONEY:"Montant total",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Montant total dépensé pour tous les services",
    DAILY_FINANCES_TOTAL_COINS:"Total des jetons métalliques utilisés",
    DAILY_FINANCES_DOWNLOAD_CSV:"Télécharger CSV",
    DAILY_FINANCES_ONLINE:"R2W Online",
    DAILY_FINANCES_OFFLINE:"Espèces",
    DAILY_FINANCES_CHANGER:"Espèces du changeur",
    DAILY_FINANCES_COINS:"Jetons/Eurokey",
    REPORTS_FILTER:"Filtre",
    REPORTS_TYPE_OF_REPORT:"Type de rapport",
    REPORTS_CHOOSE_FACILITY:"Choisir une station de lavage",
    REPORTS_PERIOD_1:"Période 1 - ",
    REPORTS_PERIOD_2:"Période 2 - ",
    MONEY_BY_DATE_REPORT:"Montant total dépensé par date",
    R2W_BY_DATE_REPORT:"Total des paiements en ligne par date",
    COINS_BY_DATE_REPORT:"Nombre de jetons dépensés par date au total",
    AVG_MONEY_BY_HOUR_REPORT:"Dépense moyenne d'argent par heure",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Dépense moyenne d'argent par jour de la semaine",
    AVG_MONEY_BY_BOX_REPORT:"Dépenses par la piste de lavage",
    COMPARE_PERIODS_REPORT:"Tableau comparatif de données",
    TOTAL_USERS_BY_GROUP:"Nombre d'utilisateurs au total par jour",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"utilisateurs",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"visites",
    VISITS_COUNT_REPORT:"Nombre d'utilisateurs par visites",
    LOYALTY_PER_DAY_REPORT:"Nombre des jetons locaux dépensés par jour",
    LOYALTY_PER_PAYMENT_METHOD:"Nombre des jetons locaux donnés par le mode de paiement",
    VISITS:"Visites",
    VISIT:"Visite",
    TOTAL_SPENT_MONEY:"Montant total dépensé",
    MONEY:"Argent",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Montant total dépensé pour la période",
    DOWNLOAD_CSV:"Télécharger CSV",
    TOTAL_SPENT_COINS:"Jetons dépensés au total",
    TOTAL_USERS:"Nombre total d'utilisateurs",
    TOTAL_CREDIT_GIVEN:"Nombre des jetons locaux virtuels dépensés ",
    EUROKEY_BY_DATE_REPORT:"Paiements Eurokey par date au total",
    TOTAL_SPENT_EUROKEY:"Dépensé au total",
    SELECT_TYPE_OF_REPORT:"Vous devez sélectionner le type de rapport :)",
    NUMBER_OF_VISITS_TITLE:"Nombre de visites",
    NUMBER_OF_USERS_TITLE:"Nombre d'utilisateurs",
    PIECES_TITLE:"Pièces",
    TOTAL_VISITS:"Total visites",
    TOKENS_TITLE:"jetons",
    SEARCH_USERS_NO_RESULTS:"Aucun utilisateur retrouvé pour ce critère de recherche",
    SEARCH_USERS:"Chercher des utilisateurs",
    SEARCH_TELEPHONES:"Recherche par le numéro de téléphone",
    ADD_USER_TO_GROUP:"Ajouter cet utilisateur au groupe",
    REMOVE_USER_FROM_GROUP:"Supprimer cet utilisateur du groupe",
    USER_GROUP_NAME_REQUIRED:"Le champ du nom d'utilisateurs est obligatoire.",
    USER_GROUP_NAME:"Nom du groupe d'utilisateurs",
    USER_GROUPS_OVERVIEW:"Sommaire des groupes d'utilisateurs",
    USER_COUNT:"Numéro d'utilisateur",
    NEW_USER_GROUP:"Créer un nouveau groupe d'utilisateurs",
    DELETE_USER_GROUP:"Supprimer le groupe d'utilisateurs",
    UPDATE_USER_GROUP:"Modifier le groupe d'utilisateurs",
    DELETE_USER_GROUP_ERROR:"Une erreur est sourvenue lors de la suppression de ce groupe d'utilisateurs. Veuillez réessayer ou contactez le support technique...",
    CONFIRM_DELETE_USER_GROUP:"Êtes-vous sûr(e) de vouloir supprimer ce groupe d'utilisateurs?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Les activités de fidélité ne seront plus disponibles aux membres du groupe d'utilisateurs supprimé.",
    GROUP_NAME_MAX_LENGTH:"Le nom de groupe ne doit pas dépasser 255 caractères",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Cet utilisateur est déjà membre de ce groupe",
    MISSING_USER:"Utilisateur manquant",
    USER_NOT_ON_LIST:"Utilisateur n'est pas dans la liste des utilisateurs actifs. Vérifiez si l'adresse mail est corrrecte et réessayez.",
    UPLOAD_USER_GROUP:"Envoyer la liste du groupe d'utilisateurs du fichier *.csv",
    UKNOWN_USERS:"Liste des utilisateurs inconnus",
    CAMPAIGN_TEMPLATE_RULE:"Règle du modèle",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Une erreur s'est produite  lors de la suppression de modèle de cette promotion. Veuillez réessayer ou contactez le support technique...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Êtes-vous sûr(e) de vouloir supprimer ce modèle de la promotion?",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Êtes-vous sûr(e) de vouloir supprimer le modèle de campagne sélectionné?",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Sommaire de modèle de promotion",
    DELETE_CAMPAIGN_TEMPLATE:"Supprimer le modèle de promotion",
    UPDATE_CAMPAIGN_TEMPLATE:"Modifier le modèle de promotion",
    CREATE_CAMPAIGN_TEMPLATE:"Créer le nouveau modèle de promotion",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Nom de modèle de promotion est le champ obligatoire.",
    CAMPAIGN_TEMPLATE_NAME:"Nom du modèle de promotion",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Champ obligatoire",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"donner %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"du temps en plus",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Tout d'abord veuillez sélectionner le type. Les pistes de lavage ou les petites machines.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Supprimer cette règle",
    CAMPAIGN_TEMPLATE_RULE_FROM:"du",
    CAMPAIGN_TEMPLATE_RULE_TO:"jusqu'au",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"heures",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minutes",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Nouvelle règle par le nombre de visites",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Nouvelle règle par le jetons dépensé",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Nouvelle règle par les jours de la semaine",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Ajouter une nouvelle règle",
    CAMPAIGN_TEMPLATE_RULE_1:"Chaque",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Chaque",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"les jetons dépensés dans moins de",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"visites dans moins de",
    CAMPAIGN_TEMPLATE_RULE_3:"jours",
    CAMPAIGN_TEMPLATE_RULE_4:"jetons",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Aucune règle dans la liste.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Date ne peut pas être dans le passé",
    DELETE_CAMPAIGN_ERROR:"Une erreur s'est produite lors de la suppression de promotion. Veuillez réessayer ou contactez le support technique...",
    CONFIRM_DELETE_CAMPAIGN:"Êtes-vous sûr(e) de vouloir supprimer la promotion choisie?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W n'est pas responsable de l'expérience utilisateur causée par cette action.",
    CAMPAIGNS_OVERVIEW:"Sommaire de promotion",
    DELETE_CAMPAIGN:"Supprimer la promotion",
    UPDATE_CAMPAIGN:"Modifier la promotion",
    CREATE_CAMPAIGN:"Créer nouvelle promotion",
    CAMPAIGN_ACTIVE:"Active",
    CAMPAIGN_TEMPLATE:"Modèle",
    CAMPAIGN_GROUPS:"Groupes",
    CAMPAIGN_ALL_USERS:"Tous les utilisateurs",
    CAMPAIGN_NAME:"Nom de promotion",
    CAMPAIGN_NAME_REQUIRED:"Nom de promotion est le champ obligatoire",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Nombre des utilisateurs qui ont presque atteint le seuil par jour",
    MESSAGE_TO_USERS:"Message pour les utilisateurs retrouvés",
    SEND_MESSAGE:"Envoyer le message",
    THRESHOLD:"Seuil",
    TYPE:"Type",
    TOTAL_MONEY_SPENT:"L'argent dépensé dans la promotion au total",
    NUMBER_OF_VISITS:"Nombre des visites dans la promotion",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Message doit contenir au moins 10 caractères",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Message ne doit pas contenir plus de 350 caractères ",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Le texte de message est obligatoire",
    TECHNOLOGY:"Technologie",
    TAP_WATER:"L'eau du robinet",
    REVERSE_OSMOSIS:"L'osmose inverse",
    SOFTENED_WATER:"L'eau aducie",
    DOSER:"Doseur",
    STATUS:"Etat",
    LAST_SYNCHRONIZATION:"Dernière synchronisation",
    NO_OF_CURRENT_ALARMS:"Nombre d'alarmes actives",
    NO_OF_CURRENT_WARNINGS:"Nombre d'avertissements actuels",
    WEATHER:"La météo",
    BOXES_WORK_HOURS_COUNTERS:"Compteurs des heures d'activité des pistes de lavage",
    BOX_TOTAL_HOURS:"Heures d'activité des pistes de lavage au total",
    BOX_SERVICE_HOURS:"Heures d'activité au total (le service)",
    BOX_COUNTER_HOURS:"Heures",
    ALARMS_AND_WARNINGS:"Alarmes et avertissements",
    FILTER_AND_BOILER:"Filtre et chaudière",
    FILTER_TOTAL_DAYS:"Jours d'activité des filtres",
    BOILER_TOTAL_DAYS:"Jours d'activité de chaudière",
    DAYS_UNIT:"jours",
    SOFTENER:"Adoucisseur d'eau",
    MANUAL_COLD_DRAIN:"Drainage froid manuel",
    EL_COLD:"El. froid",
    DRAIN:"drainage",
    TAP:"robinet",
    WASTE:"Déchet",
    OSMOSIS:"osmose",
    DEMI_WATER:"L'eau déminéralisée",
    EL_RINSE:"El. m. rinçage",
    BOILER:"Chaudière",
    EL_WAX:"El. m. cire",
    FLOOR_HEATING:"Chauffage du sol",
    DOSER_TANK:"Réservoir de doseur",
    EL_WASH:"El. m. lavage",
    DETERGENT:"Détergent",
    VIBRATOR:"Vibrateur",
    UPDATE_FACILITY_SETTINGS:"Modifier les paramètres de la station de lavage",
    GENERAL_SETTINGS:"Paramètres généraux",
    LIGHTS:"Lumière",
    GROUPS:"Groupes",
    ANTI_FREEZE:"Antigel",
    AUTO:"Auto",
    MANUAL:"Manuel",
    ON:"Activé",
    OFF:"Désactivé",
    TEMPERATURE:"Température",
    UPDATE_DEVICE:"Mettre à jour les paramètres de la station de lavage",
    BOX_CLEAN_HOURS:"Compteurs des heures d'activité (nettoyage)",
    GROUP_COUNTERS:"Compteurs de groupes",
    RESET:"Réinitialiser",
    CASH_COUNT:"Compteur des pièces de monnaie",
    COINS_COUNT:"Compteur des jetons",
    EUROKEY_COUNT:"Compteur Eurokey",
    DOSER_WORK:"Heures d'activité du doseur(sec.)",
    DOSER_PAUSE:"Heures de pause du doseur(sec.)",
    DELAY_BFV:"BFV retard (ms)",
    DELAY_6M1:"6M1 retard (ms)",
    DELAY_LPS:"LPS retard (ms)",
    RESET_CASH_COUNT_ALL:"Réinitialiser tous les compteurs de pièces en métal",
    RESET_COINS_COUNT_ALL:"Réinitialiser tous les compteurs de jetons",
    RESET_EUROKEY_COUNT_ALL:"Réinitialiser tous les compteurs d'Eurokey",
    FACILITY_DETAILS:"Détails de la station de lavage",
    FACILITY_NAME:"Nom de la station de lavage",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Photo envoyée avec succès",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Données modifiées avec succès",
    CONNECTED:"Connecté",
    DISCONNECTED:"Déconnecté(e)",
    OFFLINE:"Débranché",
    MESSAGES_FILTER:"Filtre de messages",
    FACILITY:"Station de lavage",
    APPLY:"Appliquer",
    TIME:"Temps",
    LOCATION:"Localisation",
    ACKNOWLEDGED:"Reconnue",
    FILTERED_MESSAGES:"Messages filtrés",
    ACK:"Reconnue",
    NOT_ACK:"Pas reconnue",
    ALL:"Toutes",
    ALL_FACILITIES:"Toutes les stations de lavage",
    ENTER_DATE_PLACEHOLDER:"Renseignez la date",
    OP_NESTANAK_NAPONA:"Voltage manquant sur l'indicateur de phase 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"La baisse du disjoncteur de la pompe haute pression",
    OP_UPR_NAPON_24VAC_GRE:"Absence 24VAC Disjoncteur -5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Réservoir d'eau potable est vide",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"La baisse du disjoncteur de la pompe de l'eau potable",
    OP_MIN_NIVO_OMEKS_VODE:"Réservoir d'eau adoucie est vide",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"La baisse du disjoncteur de la pompe de l'eau adoucie",
    OP_MIN_NIVO_DEMIN_VODE:"Réservoir de l'eau déminéralisée est vide",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"La baisse du disjoncteur de la pompe de l'eau déminéralisée",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"La baisse du disjoncteur de la pompe pour déminéralisation de l'eau",
    OP_BOJLER_GRESKA_MZS:"Erreur sur la chaudière",
    OP_CRPKA_PRASKA_GRE_MZS:"La baisse du disjoncteur de la pompe de circulation d'eau chaude",
    OP_DOZATOR_PRASKA_GRE_MZS:"La baisse du disjoncteur sur le moteur du doseur de détergent",
    OP_VIBRATOR_PRASKA_GRE_MZS:"La baisse du disjoncteur sur le vibrateur de doseur de détergent",
    OP_MIN_PRASAK_TON_ALARM:"Réservoir du détergent est vide",
    OP_USIS_KOV_TURBINA_GRESKA:"La baisse du disjoncteur sur la turbine pour l'aspiration des pièces",
    OP_FILTER_VODE_ZACEPLJEN:"Filtre pour l'eau bloqué",
    OP_VISKTL_RESET_SATI_RADA:"Service de pompe de haute pression",
    OPW_VISKTL_RESET_SATI_RADA:"Service de pompe de haute pression",
    OP_FILTER_DANI_RADA:"Erreur sur le filtrage de l'eau",
    OP_BOJLER_DANI_RADA:"Erreur sur la chaudière",
    OPW_ALARM_VISOKOTL_PUMPA:"Alarme sur la pompe de haut pression",
    OPW_ALARM_FILTER_SERVIS:"Alarme sur le service de filtrage d'eau",
    OPW_ALARM_BOJLER_SERVIS:"Alarme sur le service de chaudière",
    HAS_MEMBERS:"Le groupe sélectionné possède des membres et ne peut pas être supprimé. Les membres doivent d'abord être supprimés.",
    PERIODIC_SUMMARY_FOR:"RAPPORT PÉRIODIQUE POUR",
    PERIODIC_SUMMARY_REPORTS:"Rapports périodiques de synthèse",
    DATE_RANGE:"Période",
    FINANCIAL_REPORT:"Rapport financier",
    GROSS_INCOME:"Revenus brut",
    GROSS_INCOME_SUM:"Somme de revenus",
    COMMISSION_FEE:"Frais de commission",
    NET_INCOME:"Revenu net (pour facturation)",
    COMMISSION_FEE_DETAILS:"Frais de comission comprend la provision bancaire / PayPal ou les frais SMS de fournisseur.",
    LOYALTY_CREDITS_REPORT:"Rapport de jetons locaux",
    LOYALTY_GIVEN:"Jetons locaux donnés",
    LOYALTY_USED:"Jetons locaux utilisés",
    LOYALTY_SOLD:"Jetons locaux chargés",
    LOYALTY_TOTAL:"Total",
    LOYALTY_CURRENT_MONTH:"Mois en cours",
    SOMETHING_WENT_WRONG:"Ouuups, une erreur est sourvenue",
    MISSING_PAGE:"Désolé, nous ne pouvons pas retrouver la page demandée",
    TRY_AGAIN:"Veuillez réessayer",
    DEFAULT_ERROR_NAME:"Une erreur inconnue est sourvenue",
    DEFAULT_ERROR_DESCRIPTION:"Veuillez réessayer, si le problème n'est pas résolu, veuillez contacter la personne en charge",
    MY_ACCOUNT_DETAILS:"Détails de votre compte",
    SAVE_CHANGES:"Sauvegarder les modifications",
    USERNAME:"Nom d'utilisateur",
    FIRST_NAME:"Prénom",
    LAST_NAME:"Nom",
    USER_ROLE:"Groupe d'utilisateurs",
    OLD_PASSWORD:"Ancien mot de passe",
    NEW_PASSWORD:"Nouveau mot de passe",
    OLD_PASSWORD_REQUIRED:"Le champ pour l'ancien mot de passe est obligatoire",
    NEW_PASSWORD_REQUIRED:"Le champ pour le nouveau mot de passe est obligatoire",
    NEW_PASSWORD_REPEAT:"Le champ pour confirmer le mot de passe est obligatoire",
    NEW_PASSWORD_NOT_MATCH:"Le mot de passe ne correspond pas à nouveau mot de passe",
    PASSWORD_DIFFERENT_VALIDATION:"Le nouveau mot de passe doit être différent de l'ancien",
    PASSWORD_MIN_CHAR:"Votre mot de passe doit contenir au moins 8 caractères",
    PASSWORD_MAX_CHAR:"Votre mot de passe ne doit pas contenir plus de 32 caractères",
    PASSWORD_PATTERN_VALIDATION:"Mot de passe doit contenir au moins un chiffre, une lettre en majuscule et une en miniscule ",
    ACCOUNT_MANAGEMENT:"Gestion de compte",
    NOT_ACTIVE:"Inactif",
    ASSIGN_ROLE:"Attribuer un rôle",
    UPDATE:"Mettre à jour",
    ADD_NEW_ACCOUNT:"Ajouter un nouveau compte",
    EMAIL_REQUIRED:"Adresse e-mail est obligatoire",
    EMAIL_NOT_VALID:"Adresse e-mail n'est pas valide",
    ADD_NEW_USER_TEXT:"Le mail avec le lien d'activation sera envoyé à l'adresse e-mail enrégistrée",
    UPDATE_USER_NOTIFICATION:"Les données mises à jour avec succès",
    CHANGED_PASSWORD_NOTIFICATION:"Le mot de passe modifié avec succès",
    UPDATE_USER_GROUP_NOTIFICATION:"Le nom de groupe modifié avec succès",
    CREATE_USER_GROUP_NOTIFICATION:"Groupe d'utilisateurs créé avec succès",
    DETELE_USER_GROUP_NOTIFICATION:"Groupe d'utilisateurs supprimé avec succès",
    EMPTY_GROUP_LIST_MSG:"Aucun groupe d'utilisateurs créé. Pour commencer, créer un groupe d'utilisateurs",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"L'utilisateur supprimé du groupe avec succès",
    ADD_USER_TO_GROUP_NOTIFICATION:"L'utilisateur ajouté au groupe avec succès",
    ADD_USER_NOTIFICATION:"Le nouvel utilisateur ajouté avec succès",
    DELETE_USER_NOTIFICATION:"L'utilisateur supprimé avec succès",
    RESEND_USER_VERIFICATION_EMAIL:"L'e-mail de vérification a bien été envoyé.",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Pour créer un groupe d'utilisateurs, veuillez enrégistrer le nom du groupe.",
    DELETE_USER:"Supprimer les utilisateurs",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Êtes-vous sûr(e) de vouloir supprimer cet utilisateur du groupe?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Cher(Chère) utilisateur R2W, si vous nous rendez visite pendent notre promotion du mois en cours, vous recevrez le bonus sur votre compte.",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Règle de promotion par le nombre de visites",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Règle de promotion par le nombre des jetons dépensés",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Règle de promotion par le jour de la semaine",
    REMOVE_CAMPAIGN_RULE_TITLE:"Annuler les règles de promotion",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Êtes-vous sûr(e) de vouloir supprimer cette règle de promotion?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Une nouvelle promotion créée avec succès",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Une nouvelle promotion activée avec succès",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Pas de promotions créées. Pour commencer, veuillez en créer une ",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Message envoyé avec succès",
    COMPANY_ACCOUNTS:"Comptes de la société",
    BUSSINESS_INVOICES_LIST:"Mes factures B2B",
    LOCALE_TOKEN:"Jeton local",
    R2W:"Jeton global",
    START_MONTH:"Mois de début",
    END_MONTH:"Mois de fin",
    TOKEN_TYPE:"Type de jeton",
    TOKEN_NUMBER:"Numéro de jeton",
    NOTHING_TO_DISPLAY:"* Rien à afficher",
    CREATE_INVOICE:"Créer la facture",
    INVOICE:"Facture",
    INVOICES:"Factures",
    EDIT_INVOICE:"Modifier la facture",
    UPDATE_INVOICE_NOTIFICATION:"Vous avez mis à jour la facture à l'état 'En cours' avec succès",
    CURRENT_CHARGES:"Vos obligations pour la période en cours",
    PAYMENTS_ON_HOLD:"Factures en cours de traitement",
    FOR_INVOICING:"Pour la facturation",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Vous êtes en train d'annuler la facture",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Êtes-vous sûr(e) de vouloir annuler cette facture ?",
    INVOICING_NOTIFICATION_HEADER:"Vous êtes sur le point de faire de la facturation",
    INVOICING_NOTIFICATION_TEXT:"Êtes-vous sûr(e) de vouloir envoyer la facture?",
    SENT_INVOICE_NOTIFICATION:"Vous avez envoyé la facture avec succès",
    CANCELED_INVOICE_NOTIFICATION:"Votre facture a été annulée avec succès",
    INVOICE_DESCRIPTION_TEXT:"Facture pour le mois ",
    INVOICE_STATE:"Etat de la facture",
    INVOICE_NUMBER:"Numéro de facture",
    INVOICE_TOTAL:"Total",
    SELECT_YEAR:"Choisir une année",
    DOWNLOAD:"Télécharger PDF",
    INVOICE_NUMBER_HEADER:"Vous allez envoyer la facture avec le numéro ",
    INVOICE_PAYMENT_CONFIRMATION:"Vous êtes en train de confirmer le paiement de la facture ",
    INSERT_INVOICE_NUMBER:"Saisir le numéro de la facture",
    INVOICED_WARNING:"E-mail n'est pas envoyé. Veuillez patienter ...",
    SEND_INVOICE:"Envoyer",
    INVOICE_ALL:"Tout",
    INVOICE_FROM_R2W:"de R2W",
    INVOICE_TO_R2W:"à R2W",
    PAYMENT_REQUEST:"Demande de paiement",
    PAYMENT_REQUEST_STATE:"État de la demande de paiement",
    PAYMENT_REQUEST_NUMBER:"Numéro de la demande de paiement",
    FOR_PAYMENT_REQUEST:"Pour paiements demandés",
    PAYMENT_REQUEST_ON_HOLD:"Demande de paiement en cours de traitement",
    DOWNLOAD_INVOICE:"Télécharger la facture",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Cliquez pour les options de téléchargement",
    B2B_SPEC:"B2B spécification",
    B2C_SPEC:"B2C spécification",
    DOWNLOAD_PAYMENT_REQUEST:"Télécharger la demande de paiement",
    LOYALTY_PREVIEW:"Prévisualisation de la promotion",
    ACTIVATED:"Activé",
    RUNNING:"En cours",
    NOT_ACTIVATED:"Pas activée",
    FINISHED:"Finie",
    DEPRECATED:"Obsolète",
    UPCOMING:"A venir",
    NONE:"Personne",
    STARTED:"Commencé",
    ENDS:"Se termine",
    DEDICATED:"Attribuée à",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Vous êtes en train d'activer",
    CAMPAIGN:"promotion",
    SEND_MESSAGE_NOTIFICATION:"Vous allez envoyer le message à tous les groupes d'utilisateurs",
    DIVISIBLE_TO_NUMBER:"Le nombre doit être divisible par ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Type d'appareil",
    LISTENER:"Petites machines",
    BRIDGE:"Pistes de lavage",
    WASH_BOXES:"Pistes de lavage",
    VACUUMS:"Aspirateurs",
    SAVE_NEWS:"Sauvegarder l'actualité",
    CREATE_NEW_NEWS:"Créer une actualité",
    HISTORY_OF_ALL_NEWS:"Historique de toutes les actualités",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Saisir le nom de la station de lavage",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Ajouter une autre station de lavage",
    NEWS_TEXT:"Texte de l'actualité",
    NEWS_TITLE:"Titre de l'actualité",
    DELETE_NEWS_CONFIRMATION:"Voulez-vous supprimer cette actualité ?",
    NEWS_DELETE_NOTIFICATION:"L'actualité supprimée avec succès",
    NEWS_SAVE_NOTIFICATION:"L'actualité sauvegardée avec succès",
    NEWS_CREATION_DATE:"Date d'enregistrement",
    NO_TITLE:"Sans titre",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Texte ne doit pas contenir plus de 255 caractères",
    NEWS_TEXT_REQUIRED_VALIDATION:"Texte de l'actualité est obligatoire",
    NEWS_TITLE_REQUIRED_VALIDATION:"Titre de l'actualité est obligatoire",
    DEACTIVATE:"Désactiver",
    ASIDE_MENU_LOCAL_TOKENS:"Jetons locaux",
    CREATE_NEW_LOCAL_TOKENS:"Emission de nouveaux jetons locaux",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Saisissez l'adresse e-mail d'utilisateur et le nombre de jetons à envoyer",
    CREATE_TOKENS:"Jetons envoyés",
    MINIMUM_ONE_TOKEN:"Valeur saisie doit être suppérieure de 0",
    CUSTOMER_EMAIL:"Adresse e-mail de l'utilisateur",
    AMOUNT_OF_TOKENS:"Nombre de jetons",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Jetons locaux émis avec succès pour",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Une erreur s'est produite lors d'émission des jetons locaux. Merci de vérifier l'adresse e-mail d'utilisateur et puis réessayez.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Historique d'émission des jetons locaux",
    ISSUED_AT:"émis à",
    ISSUED_BY:"émis par",
    CODE:"Code",
    REDEEMED_BY:"Utilisé par",
    REDEEMED_AT:"Utilisé à",
    ASIDE_MENU_VOUCHERS:"Coupon",
    PRINT:"Imprimer",
    VOUCHERS_OVERVIEW:"Sommaire des coupons",
    CREATE_NEW_VOUCHERS:"Créer de nouveaux coupons",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Créez une nouvelle série de coupons en indiquant le nombre de jetons par un coupon, le nombre de coupons par série et le code préfixe de la série",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Nombre de jetons par un coupon",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Il est possible d'attribuer entre 1 à 100 jetons par coupon",
    NUMBER_OF_NEW_VOUCHERS:"Nombre de coupons par série",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Il est possible de créer entre 1 et {{size}} coupons par une série",
    NEW_VOUCHERS_PREFIX:"Le code préfixe de coupon dans la série",
    VALIDATION_VOUCHER_PREFIX:"Le préfixe de code doit contenir exactement 4 caractères (lettres majuscules et / ou chiffres)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Une erreur s'est produite lors de la création de nouveaux vouchers. Veuillez réessayer ou contactez notre service de support.",
    CREATE_VOUCHERS:"Créer une série de coupons",
    CREATING_VOUCHERS_SUCCESS:"Nouvelle série de coupons créée avec succès",
    PRINT_NEW_VOUCHERS:"Imprimer les coupons",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Nombre de jetons par un coupon",
    PRINT_VOUCHERS_PREFIX:"Préfixe de code (de série) de coupons",
    NO_VOUCHERS_FOR_PRINT:"Aucun coupon retrouvé sous le code préfixe saisi",
    PRINT_VOUCHERS:"Imprimer les coupons",
    VALIDATION_VOUCHER_CODE_FILTER:"Le filtre de recherche des coupons doit être composé de 1 à 16 caractères dont les lettres en majuscule et les chiffres.",
    FILTER_VOUCHERS_BY_CODE:"Rechercher les voucher par le code",
    FILTER_VOUCHERS:"Recherche",
    WASH_BOX:"Piste de lavage",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Total des jetons numériques utilisés",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Nombre total de jetons locaux vendus par date",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Total de jetons locaux dépensés par date",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Nombre total de jetons locaux par date",
    LOCAL_TOKEN:"Jeton local ",
    GIVEN_TOKEN:"Jetons locaux donnés",
    SOLD_TOKEN:"Jetons locaux vendus",
    SMALL_MACHINES:"Petites machines",
    R2W_Listener:"Listener",
    HHANLE_DEVICE:"HHanle - Piste de lavage",
    CODE_PREFIX_EXIST:"Le préfixe du code existe déjà",
    CODE_PREFIX_EXIST_TEXT:"Vous ne pouvez pas créer le nouveau coupon avec ce préfixe du code. Veuillez définir un autre.",
    MIN_FOUR_VALIDATION:"Exactement 4 caractères",
    ALL_INFORMATION_1:"Toutes les informations sur",
    ALL_INFORMATION_2:"sera perdu",
    ASIDE_MENU_TRANSACTIONS:"Transactions",
    EXPENSES:"Les dépenses",
    TOPUPS:"Jetons achetés",
    EXPENSES_LIST:"Liste des dépenses",
    USER_EMAIL:"Email d'utilisateur",
    COMPANY_NAME:"Nom de la compagnie",
    TOPUPS_LIST:"Liste des jetons achetés",
    CONSUMER:"Consommateur",
    SYSTEM_ADMIN:"Administrateur de système",
    MERCHANT_ADMIN:"Administrateur marchand",
    COMPANY_ADMIN:"Administrateur de companie",
    FACILITY_ADMIN:"Administrateur de site de lavage",
    SUBSCRIBER:"Souscripteur",
    CONFIGURATOR:"Configurateur",
    SETUP_UNIT_SERIAL_NO:"Numéro de serie",
    SETUP_UNIT_MATERIAL_NO:"Numéro d'article",
    SETUP_UNIT_WEBAPI_VERSION:"Version WebApi",
    TOTAL_TURNOVER:"Rotation de site de lavage",
    AVAILABILITY_ALL:"Disponibilité",
    AVAILIBILITY:"Disponibilité des pistes de lavage",
    AVAILABILITY_VACUUMS:"Disponibilité des aspirateurs :",
    WASH_BOX_INFO:"Information sur les pistes de lavage",
    VACUUM_CLEANER_INFO:"Information sur les aspirateurs",
    BREAD_CRUMBS_SERVICE:"Service",
    HOLIDAYS:"Jours fériés",
    HOLIDAY:"Jour férié",
    LIGHTS_ON:"Lumières allumées",
    LIGHTS_OFF:"Lumières éteintes",
    WASH_BOXES_ON:"Piste de lavage connectée",
    WASH_BOXES_OFF:"Piste de lavage déconnectée",
    VACUUMS_ON:"Aspirateurs connectés",
    VACUUMS_OFF:"Aspirateurs déconnectés",
    TURNOVER:"Rotation",
    TURNOVER_MANUAL_WASH_UNIT:"Rotation manuel",
    STATUS_BAY_RUN_TIME:"Heures d'activité de la piste de lavage au total",
    STATUS_BAY_PROGRAM_NAME:"Nom du programme",
    STATUS_BAY_CREDIT:"Le crédit de la piste de lavage",
    CLOUD_KREDIT:"Le crédit du cloud",
    STATUS_VACUUM_RUN_TIME:"Heures d'activité de l'aspirateur",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Afficher des informations du service et programme",
    UNAVAILABLE:"L'unité est indisponible",
    SHOW_HIDE_TABLE:"Afficher / masquer la table des heures d'activité",
    PROGRAM_NAME:"Nom du programme",
    PROGRAM_OPTION:"Option du programme",
    DEVICE:"Appareil",
    QUANTITY:"Quantité",
    PROGRAM_COUNTER:"Compteur du programme",
    NO_NAME:"La référence n'a pas de nom",
    COUNTER_SERVICE_DATA:"Données de la service",
    NEED_SERVICE:"Service requis",
    PROGRAM_DATA:"Données du programme de la piste de lavage",
    CURRENT_FAULT_DATA:"Données sur les défauts actuels",
    REFERENCE_DUE:"Echue",
    REFERENCE_SECONDS:"Secondes",
    REFERENCE_NAME:"Nom de la référence",
    WASHBOX_NAME:"Nom de la piste de lavage",
    FAULT_NAME:"Nom du défaut",
    FAULT_NUMBER:"Numéro du défault",
    CURRENT_FAULT_COUNT:"Défaults actifs",
    DEVICE_NOT_INSTALLED:"Appareil non installé",
    STATUS_READY:"État prêt",
    STATUS_ERROR:"Etat d'erreur",
    CONNECTION_ERROR:"Déconnecté",
    UNKNOWN_RESET:"Erreur de logiciel",
    SOFTWARE_RESET:"Erreur de logiciel",
    EXTERNAL_PIN_RESET:"Erreur de logiciel",
    RESTART_OR_BROWNOUT_OCCURRED:"Erreur de logiciel",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Erreur de progiciel",
    COULD_NOT_SIMULATE_COIN:"Erreur de progiciel",
    ERROR_SETTING_INHIBIT_MODE:"Erreur de progiciel",
    OFFLINE_DEVICE:"La piste de lavage déconnectée",
    TARIFFS:"Tarif",
    DAY:"Jour",
    NIGHT:"Nuit",
    VOUCHER_CODE:"Code de coupon",
    DISMISS_ALARM:"Réinitialiser l'alarme ?",
    ALARM_ACTIVE:"Alarmes actives",
    NO_ALARM_ACTIVE:"Il n'y a aucune alarme active.",
    ALARM_HISTORY:"Historique des alertes",
    MANAGING_TOKENS:"Gérer les jetons",
    EXPIRATION_DATE:"Date d'expiration",
    EXTEND_TOKEN_DATE:"Prolonger la date d'expiration du jeton pour",
    DELETE_TOKENS_FOR:"Supprimer les jetons pour",
    PUMP_TYPE:"Type de pompe",
    TURN_OFF_DEVICE:"Statut de l'appareil",
    OPERATION_DATA:"Données de l'opération",
    PUMP_DATA:"Données de la pompe",
    PUMP_NAME:"Nom de la pompe",
    POINT_NAME:"Nom du point",
    CHANGER_INCOME:"Revenu total du distributeur de jetons par date",
    SELECTED_OPEN:"Ouvert pendant les heures de travail sélectionnées",
    ALWAYS_OPEN:"Toujours ouvert (24/7)",
    CLOSED:"Fermé",
    CLOSED_24:"Fermé 24 heures",
    OPENED_24:"Ouvert 24 heures",
    MON:"Lundi",
    TUE:"Mardi",
    WED:"Mercredi",
    THU:"Jeudi",
    FRI:"Vendredi",
    SAT:"Samedi",
    SUN:"Dimanche",
    PRICING:"Tarif",
    PRICE:"Prix",
    VALIDITY:"Validité",
    TOKEN_PACKAGES:"Packs de jetons",
    SINGLE_WASH:"Lavage seul",
    FACILITY_WORKING_HOURS:"Indiquer les horaires d'ouverture de la station de lavage sélectionnée",
    WORKING_HOURS_ALWAYS_OPEN:"Toujours ouvert",
    WORKING_HOURS_ALWAYS_CLOSE:"Fermé par l'exploitant",
    WORKING_HOURS_CUSTOM:"Indiquer les horaires d'ouverture",
    KARCHER_ERROR_CODE:"Alerte code d'erreur",
    KARCHER_ERROR_MESSAGE_1:"Prises électroniques surchargées",
    KARCHER_ERROR_MESSAGE_2:"Le séparateur d'huile doit être vidé",
    KARCHER_ERROR_MESSAGE_4:"Le sensor d'obscurcissement défectueux",
    KARCHER_ERROR_MESSAGE_5:"Le commutateur du moteur protecteur des pompes de haute pression s'est déclenché.",
    KARCHER_ERROR_MESSAGE_6:"Connexion au RDS défectueuse",
    KARCHER_ERROR_MESSAGE_7:"Le commutateur de pression pour l'air sur le compresseur ne signale aucun",
    KARCHER_ERROR_MESSAGE_8:"Cause: pas de connexion avec l'électronique 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"Pas de connexion avec l'électronique de la pompe à la station 1",
    KARCHER_ERROR_MESSAGE_11:"Les prises électroniques de la station de lavage 1 sont surchargées",
    KARCHER_ERROR_MESSAGE_12:"La prise de courant de la pompe haute pression à la station de lavage 1 est trop élevée",
    KARCHER_ERROR_MESSAGE_13:"La prise de courant de la pompe haute pression à la station de lavage 1 est trop faible",
    KARCHER_ERROR_MESSAGE_14:"Contact de la pompe haute pression à la station de lavage 1 coincé",
    KARCHER_ERROR_MESSAGE_15:"Valve semi-automatique à la station de lavage 1 défectueuse",
    KARCHER_ERROR_MESSAGE_16:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 1 ",
    KARCHER_ERROR_MESSAGE_17:"Niveau d'huile de la pompe haute pression à la station de lavage 1 est trop bas",
    KARCHER_ERROR_MESSAGE_18:"L'électronique à la station de lavage 1 défectueuse",
    KARCHER_ERROR_MESSAGE_19:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 1",
    KARCHER_ERROR_MESSAGE_20:"Pas de connexion avec l'électronique de commande à distance à la station 1",
    KARCHER_ERROR_MESSAGE_21:"Défaut à l'accepteur de pièces à la station de lavage 1",
    KARCHER_ERROR_MESSAGE_22:"Défaut à l'accepteur de pièces à la station de lavage 1",
    KARCHER_ERROR_MESSAGE_30:"Pas de connexion avec l'électronique de la pompe à la station 2",
    KARCHER_ERROR_MESSAGE_31:"Les prises électroniques de la station de lavage 2 sont surchargées",
    KARCHER_ERROR_MESSAGE_32:"La prise de courant de la pompe haute pression à la station de lavage 2 est trop élevée",
    KARCHER_ERROR_MESSAGE_33:"La prise de courant de la pompe haute pression à la station de lavage 2 est trop faible",
    KARCHER_ERROR_MESSAGE_34:"Contact de la pompe haute pression à la station de lavage 2 coincé",
    KARCHER_ERROR_MESSAGE_35:"Valve semi-automatique à la station de lavage 2 défectueuse",
    KARCHER_ERROR_MESSAGE_36:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 2 ",
    KARCHER_ERROR_MESSAGE_37:"Niveau d'huile de la pompe haute pression à la station de lavage 2 est trop bas",
    KARCHER_ERROR_MESSAGE_38:"L'électronique à la station de lavage 2 défectueuse",
    KARCHER_ERROR_MESSAGE_39:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 2",
    KARCHER_ERROR_MESSAGE_40:"Pas de connexion avec l'électronique de commande à distance à la station 2",
    KARCHER_ERROR_MESSAGE_41:"Défaut à l'accepteur de pièces à la station de lavage 2",
    KARCHER_ERROR_MESSAGE_42:" Défaut à l'accepteur de pièces à la station de lavage 2",
    KARCHER_ERROR_MESSAGE_50:"Pas de connexion avec l'électronique de la pompe à la station 3",
    KARCHER_ERROR_MESSAGE_51:"Les prises électroniques de la station de lavage 3 sont surchargées",
    KARCHER_ERROR_MESSAGE_52:"La prise de courant de la pompe haute pression à la station de lavage 3 est trop élevée",
    KARCHER_ERROR_MESSAGE_53:"La prise de courant de la pompe haute pression à la station de lavage 3 est trop faible",
    KARCHER_ERROR_MESSAGE_54:"Contact de la pompe haute pression à la station de lavage 3 coincé",
    KARCHER_ERROR_MESSAGE_55:"Valve semi-automatique à la station de lavage 3 défectueuse",
    KARCHER_ERROR_MESSAGE_56:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 3",
    KARCHER_ERROR_MESSAGE_57:"Niveau d'huile de la pompe haute pression à la station de lavage 3 est trop bas",
    KARCHER_ERROR_MESSAGE_58:"L'électronique à la station de lavage 3 défectueuse",
    KARCHER_ERROR_MESSAGE_59:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 3",
    KARCHER_ERROR_MESSAGE_60:"Pas de connexion avec l'électronique de commande à distance à la station 3",
    KARCHER_ERROR_MESSAGE_61:"Défaut à l'accepteur de pièces à la station de lavage 3",
    KARCHER_ERROR_MESSAGE_62:"Défaut à l'accepteur de pièces à la station de lavage 3",
    KARCHER_ERROR_MESSAGE_70:"Pas de connexion avec l'électronique de la pompe à la station 4",
    KARCHER_ERROR_MESSAGE_71:"Les prises électroniques de la station de lavage 4 sont surchargées",
    KARCHER_ERROR_MESSAGE_72:"La prise de courant de la pompe haute pression à la station de lavage 4 est trop élevée",
    KARCHER_ERROR_MESSAGE_73:"La prise de courant de la pompe haute pression à la station de lavage 4 est trop faible",
    KARCHER_ERROR_MESSAGE_74:"Contact de la pompe haute pression à la station de lavage 4 coincé",
    KARCHER_ERROR_MESSAGE_75:"Valve semi-automatique à la station de lavage 4 défectueuse",
    KARCHER_ERROR_MESSAGE_76:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 4",
    KARCHER_ERROR_MESSAGE_77:"Niveau d'huile de la pompe haute pression à la station de lavage 4 est trop bas",
    KARCHER_ERROR_MESSAGE_78:"L'électronique à la station de lavage 4 défectueuse",
    KARCHER_ERROR_MESSAGE_79:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 4",
    KARCHER_ERROR_MESSAGE_80:"Pas de connexion avec l'électronique de commande à distance à la station 4",
    KARCHER_ERROR_MESSAGE_81:"Défaut à l'accepteur de pièces à la station de lavage 4",
    KARCHER_ERROR_MESSAGE_82:"Défaut à l'accepteur de pièces à la station de lavage 4",
    KARCHER_ERROR_MESSAGE_90:"Pas de connexion avec l'électronique de la pompe à la station 5",
    KARCHER_ERROR_MESSAGE_91:"Les prises électroniques de la station de lavage 5 sont surchargées",
    KARCHER_ERROR_MESSAGE_92:"La prise de courant de la pompe haute pression à la station de lavage 5 est trop élevée",
    KARCHER_ERROR_MESSAGE_93:"La prise de courant de la pompe haute pression à la station de lavage 5 est trop faible",
    KARCHER_ERROR_MESSAGE_94:"Contact de la pompe haute pression à la station de lavage 5 coincé",
    KARCHER_ERROR_MESSAGE_95:"Valve semi-automatique à la station de lavage 5 défectueuse",
    KARCHER_ERROR_MESSAGE_96:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 5",
    KARCHER_ERROR_MESSAGE_97:"Niveau d'huile de la pompe haute pression à la station de lavage 5 est trop bas",
    KARCHER_ERROR_MESSAGE_98:"L'électronique à la station de lavage 5 défectueuse",
    KARCHER_ERROR_MESSAGE_99:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 5",
    KARCHER_ERROR_MESSAGE_100:"Pas de connexion avec l'électronique de commande à distance à la station 5",
    KARCHER_ERROR_MESSAGE_101:"Défaut à l'accepteur de pièces à la station de lavage 5",
    KARCHER_ERROR_MESSAGE_102:"Défaut à l'accepteur de pièces à la station de lavage 5",
    KARCHER_ERROR_MESSAGE_110:"Pas de connexion avec l'électronique de la pompe à la station 6",
    KARCHER_ERROR_MESSAGE_111:"Les prises électroniques de la station de lavage 6 sont surchargées",
    KARCHER_ERROR_MESSAGE_112:"La prise de courant de la pompe haute pression à la station de lavage 6 est trop élevée",
    KARCHER_ERROR_MESSAGE_113:"La prise de courant de la pompe haute pression à la station de lavage 6 est trop faible",
    KARCHER_ERROR_MESSAGE_114:"Contact de la pompe haute pression à la station de lavage 6 coincé",
    KARCHER_ERROR_MESSAGE_115:"Valve semi-automatique à la station de lavage 6 défectueuse",
    KARCHER_ERROR_MESSAGE_116:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 6",
    KARCHER_ERROR_MESSAGE_117:"Niveau d'huile de la pompe haute pression à la station de lavage 6 est trop bas",
    KARCHER_ERROR_MESSAGE_118:"L'électronique à la station de lavage 6 défectueuse",
    KARCHER_ERROR_MESSAGE_119:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 6",
    KARCHER_ERROR_MESSAGE_120:"Pas de connexion avec l'électronique de commande à distance à la station 6",
    KARCHER_ERROR_MESSAGE_121:"Défaut à l'accepteur de pièces à la station de lavage 6",
    KARCHER_ERROR_MESSAGE_122:"Défaut à l'accepteur de pièces à la station de lavage 6",
    KARCHER_ERROR_MESSAGE_130:"Pas de connexion avec l'électronique de la pompe à la station 7",
    KARCHER_ERROR_MESSAGE_131:"Les prises électroniques de la station de lavage 7 sont surchargées",
    KARCHER_ERROR_MESSAGE_132:"La prise de courant de la pompe haute pression à la station de lavage 7 est trop élevée",
    KARCHER_ERROR_MESSAGE_133:"La prise de courant de la pompe haute pression à la station de lavage 7 est trop faible",
    KARCHER_ERROR_MESSAGE_134:"Contact de la pompe haute pression à la station de lavage 7 coincé",
    KARCHER_ERROR_MESSAGE_135:"Valve semi-automatique à la station de lavage 7 défectueuse",
    KARCHER_ERROR_MESSAGE_136:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 7",
    KARCHER_ERROR_MESSAGE_137:"Niveau d'huile de la pompe haute pression à la station de lavage 7 est trop bas",
    KARCHER_ERROR_MESSAGE_138:"L'électronique à la station de lavage 7 défectueuse",
    KARCHER_ERROR_MESSAGE_139:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 7",
    KARCHER_ERROR_MESSAGE_140:"Pas de connexion avec l'électronique de commande à distance à la station 7",
    KARCHER_ERROR_MESSAGE_141:"Défaut à l'accepteur de pièces à la station de lavage 7",
    KARCHER_ERROR_MESSAGE_142:"Défaut à l'accepteur de pièces à la station de lavage 7",
    KARCHER_ERROR_MESSAGE_150:"Pas de connexion avec l'électronique de la pompe à la station 8",
    KARCHER_ERROR_MESSAGE_151:"Les prises électroniques de la station de lavage 8 sont surchargées",
    KARCHER_ERROR_MESSAGE_152:"La prise de courant de la pompe haute pression à la station de lavage 8 est trop élevée",
    KARCHER_ERROR_MESSAGE_153:"La prise de courant de la pompe haute pression à la station de lavage 8 est trop faible",
    KARCHER_ERROR_MESSAGE_154:"Contact de la pompe haute pression à la station de lavage 8 coincé",
    KARCHER_ERROR_MESSAGE_155:"Valve semi-automatique à la station de lavage 8 défectueuse",
    KARCHER_ERROR_MESSAGE_156:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 8",
    KARCHER_ERROR_MESSAGE_157:"Niveau d'huile de la pompe haute pression à la station de lavage 8 est trop bas",
    KARCHER_ERROR_MESSAGE_158:"L'électronique à la station de lavage 8 défectueuse",
    KARCHER_ERROR_MESSAGE_159:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 8",
    KARCHER_ERROR_MESSAGE_160:"Pas de connexion avec l'électronique de commande à distance à la station 8",
    KARCHER_ERROR_MESSAGE_161:"Défaut à l'accepteur de pièces à la station de lavage 8",
    KARCHER_ERROR_MESSAGE_162:"Défaut à l'accepteur de pièces à la station de lavage 8",
    KARCHER_ERROR_MESSAGE_170:"Pas de connexion à l'électronique A2",
    KARCHER_ERROR_MESSAGE_171:"Les sorties de l'électronique A2 sont surchargées",
    KARCHER_ERROR_MESSAGE_172:"Le réservoir de détergent est vide",
    KARCHER_ERROR_MESSAGE_173:"Le réservoir de détergent est vide",
    KARCHER_ERROR_MESSAGE_174:"Le réservoir de détergent est vide",
    KARCHER_ERROR_MESSAGE_175:"Le réservoir de détergent est vide",
    KARCHER_ERROR_MESSAGE_176:"Le réservoir de détergent est vide",
    KARCHER_ERROR_MESSAGE_177:"La prise de courant du châssis de la pompe est trop élevée.",
    KARCHER_ERROR_MESSAGE_178:"Pas de pression après avoir activé le lavage du dessous de caisse",
    KARCHER_ERROR_MESSAGE_190:"Pas de connexion à l'électronique A3",
    KARCHER_ERROR_MESSAGE_191:"Les sorties de l'électronique A3 sont surchargées",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Les sorties du contrôle à WSO sont surchargées",
    KARCHER_ERROR_MESSAGE_202:"Le senseur de dureté indique la présence d'eau dure après la régénération",
    KARCHER_ERROR_MESSAGE_204:"Panne de l'électronique",
    KARCHER_ERROR_MESSAGE_210:"Détecteur de niveau RÉSERVOIR TAMPON VIDE activé",
    KARCHER_ERROR_MESSAGE_211:"Détecteur de niveau CONTENEUR TAMPON VIDE et CONTENEUR TAMPON PLEIN commutent simultanément.",
    KARCHER_ERROR_MESSAGE_212:"Détecteur de niveau POMPE RO ACTIVÉE et CONTENEUR TAMPON PLEIN communent simultanément",
    KARCHER_ERROR_MESSAGE_213:"Absence de pression d'eau",
    KARCHER_ERROR_MESSAGE_214:"Défaut de préparation de l'eau fournie sur place",
    KARCHER_ERROR_MESSAGE_220:"Manque d'eau",
    KARCHER_ERROR_MESSAGE_221:"Température d'échappement trop élevée",
    KARCHER_ERROR_MESSAGE_222:"La prise de courant de la pompe de circulation pour l'eau chaude est trop élevée",
    KARCHER_ERROR_MESSAGE_223:"Défaut du brûleur",
    KARCHER_ERROR_MESSAGE_224:"Le thermostat de sécurité du brûleur s'est déclenché.",
    KARCHER_ERROR_MESSAGE_225:"Le délai du brûleur activé",
    KARCHER_ERROR_MESSAGE_226:"L'indicateur de débit ne s'est pas ouvert dans les 5 secondes suivant l'arrêt de la pompe de circulation d'eau chaude",
    KARCHER_ERROR_MESSAGE_227:"L'indicateur de débit ne s'est pas ouvert dans les 3 secondes suivant l'arrêt de la pompe de circulation d'eau chaude",
    KARCHER_ERROR_MESSAGE_228:"La sortie d'eau chaude s'apaise trop lentement après l'arrêt du brûleur",
    KARCHER_ERROR_MESSAGE_229:"Défaut de la sonde de température d'eau chaude",
    KARCHER_ERROR_MESSAGE_230:"Défaut dans la sonde de température de sortie du brûleur",
    KARCHER_ERROR_MESSAGE_231:"Défaut de la sonde de température d'eau chaude",
    KARCHER_ERROR_MESSAGE_232:"Défaut dans la sonde de température de sortie du brûleur",
    KARCHER_ERROR_MESSAGE_233:"Température de l'eau avec alimentation externe avec de l'eau chaude est plus chaude que 60°C",
    KARCHER_ERROR_MESSAGE_234:"Erreur programme anti-légionelles",
    KARCHER_ERROR_MESSAGE_235:"Température de l'eau chaude anti-légionelles non atteinte",
    KARCHER_ERROR_MESSAGE_240:"Erreur du capteur de température extérieure",
    KARCHER_ERROR_MESSAGE_241:"Erreur du capteur de température extérieure",
    KARCHER_ERROR_MESSAGE_242:"La prise de courant de la pompe de circulation pour la protection contre le gel est trop élevée",
    KARCHER_ERROR_MESSAGE_243:"La prise de courant de la pompe de circulation pour chauffage de la station de lavage est trop élevée",
    KARCHER_ERROR_MESSAGE_244:"La température de l'eau chaude est trop basse, le chauffage de la station de lavage était éteint.",
    KARCHER_ERROR_MESSAGE_245:"La consommation du tuyau de chauffage de la mousse est trop élevée.",
    KARCHER_ERROR_MESSAGE_247:"Panne de l'électronique",
    KARCHER_ERROR_MESSAGE_248:"Panne de l'électronique",
    KARCHER_ERROR_MESSAGE_250:"La prise de courant de la pompe de circulation pour le programme de lavage spécial est trop élevée",
    KARCHER_ERROR_MESSAGE_255:"Panne de l'électronique",
    KARCHER_ERROR_MESSAGE_260:"Pas de connexion à l'électronique A5",
    KARCHER_ERROR_MESSAGE_261:"Les sorties de l'électronique A5 sont surchargées",
    KARCHER_ERROR_MESSAGE_280:"Pas de connexion à l'électronique A6",
    KARCHER_ERROR_MESSAGE_281:"Les sorties de l'électronique A6 sont surchargées",
    KARCHER_ERROR_MESSAGE_282:"Consommation de courant de la pompe pour le nettoyeur de jantes trop élevée",
    KARCHER_ERROR_MESSAGE_283:"Consommation de courant de la pompe pour le nettoyeur de jantes trop basse",
    KARCHER_ERROR_MESSAGE_284:"Le contacteur de la pompe du nettoyeur de jantes est bloqué.",
    KARCHER_ERROR_MESSAGE_300:"Pas de connexion à l'électronique A7",
    KARCHER_ERROR_MESSAGE_301:"Les sorties de l'électronique A7 sont surchargées",
    KARCHER_ERROR_MESSAGE_320:"Pas de connexion à l'électronique A8",
    KARCHER_ERROR_MESSAGE_321:"Les sorties de l'électronique A8 sont surchargées",
    KARCHER_ERROR_MESSAGE_322:"Consommation de courant de la pompe pour micro-émulsion trop élevée",
    KARCHER_ERROR_MESSAGE_323:"Consommation de courant de la pompe pour micro-émulsion trop basse",
    KARCHER_ERROR_MESSAGE_324:"Le contacteur de la pompe à micro-émulsion est bloqué",
    KARCHER_ERROR_MESSAGE_340:"Pas de connexion à l'électronique A9",
    KARCHER_ERROR_MESSAGE_341:"Les sorties de l'électronique A9 sont surchargées",
    KARCHER_ERROR_MESSAGE_342:"Consommation de courant de la pompe pour le nettoyage intensif trop élevée",
    KARCHER_ERROR_MESSAGE_343:"Consommation de courant de la pompe pour le nettoyage intensif trop basse",
    KARCHER_ERROR_MESSAGE_344:"Le contacteur de la pompe pour le nettoyage intensif est bloqué",
    KARCHER_ERROR_MESSAGE_400:"Pas de pression de l'eau chaude",
    KARCHER_ERROR_MESSAGE_401:"Pas de pression de l'eau douce",
    KARCHER_ERROR_MESSAGE_402:"Perméat sans pression",
    KARCHER_ERROR_MESSAGE_403:"Pas de pression de l'eau de type 4",
    KARCHER_ERROR_MESSAGE_404:"Type 4 d'eau, température supérieure à 60 °C ou perturbation externe",
    KARCHER_ERROR_MESSAGE_405:"Pas de pression de la protection contre le gel ",
    KARCHER_ERROR_MESSAGE_406:"La pression dans la protection antigel est survenue malgré l'arrêt de la pompe antigel",
    KARCHER_ERROR_MESSAGE_410:"Erreur F 400 est survenue 4 fois dans 24 heures",
    KARCHER_ERROR_MESSAGE_411:"Erreur F 401 était active pour 300 secondes",
    KARCHER_ERROR_MESSAGE_412:"Erreur F 402 est survenue 4 fois dans 24 heures",
    KARCHER_ERROR_MESSAGE_413:"Erreur F 403 est survenue 4 fois dans 24 heures",
    KARCHER_ERROR_MESSAGE_414:"Erreur F 405 est survenue 4 fois dans 24 heures",
    KARCHER_ERROR_MESSAGE_420:"Erreur sur le distributeur des jetons 1",
    KARCHER_ERROR_MESSAGE_421:"Erreur sur le distributeur des jetons 2",
    KARCHER_ERROR_MESSAGE_440:"Pas de connexion avec l'électronique A31",
    KARCHER_ERROR_MESSAGE_441:"Les sorties de l'électronique A31 sont surchargées",
    KARCHER_ERROR_MESSAGE_500:"Connexion de l'électronique de l'aspirateur 1/2",
    KARCHER_ERROR_MESSAGE_501:"Touche de démarrage aspirateur 1 contact permanent",
    KARCHER_ERROR_MESSAGE_502:"Touche de démarrage aspirateur 2 contact permanent",
    KARCHER_ERROR_MESSAGE_510:"Connexion de l'électronique de l'aspirateur 3/4",
    KARCHER_ERROR_MESSAGE_511:"Touche de démarrage aspirateur 3 contact permanent",
    KARCHER_ERROR_MESSAGE_512:"Touche de démarrage aspirateur 4 contact permanent",
    KARCHER_ERROR_MESSAGE_520:"Connexion de l'électronique de l'aspirateur 5/6",
    KARCHER_ERROR_MESSAGE_521:"Touche de démarrage aspirateur 5 contact permanent",
    KARCHER_ERROR_MESSAGE_522:"Touche de démarrage aspirateur 6 contact permanent",
    KARCHER_ERROR_MESSAGE_530:"Connexion de l'électronique de l'aspirateur 7/8",
    KARCHER_ERROR_MESSAGE_531:"Touche de démarrage aspirateur 7 contact permanent",
    KARCHER_ERROR_MESSAGE_532:"Touche de démarrage aspirateur 8 contact permanent",
    KARCHER_ERROR_MESSAGE_540:"Connexion de l'électronique de l'aspirateur 9/10",
    KARCHER_ERROR_MESSAGE_541:"Touche de démarrage aspirateur 9 contact permanent",
    KARCHER_ERROR_MESSAGE_542:"Touche de démarrage aspirateur 10 contact permanent",
    KARCHER_ERROR_MESSAGE_550:"Connexion de l'électronique de l'aspirateur 10/11",
    KARCHER_ERROR_MESSAGE_551:"Touche de démarrage aspirateur 11 contact permanent",
    KARCHER_ERROR_MESSAGE_552:"Touche de démarrage aspirateur 12 contact permanent",
    KARCHER_ERROR_MESSAGE_800:"Pas de connexion avec l'électronique A30",
    KARCHER_ERROR_MESSAGE_801:"Les sorties de l'électronique A30 sont surchargées",
    KARCHER_ERROR_MESSAGE_802:"Erreur avec l'adoucisseur d'eau",
    KARCHER_ERROR_MESSAGE_803:"Déclenchement de l'interrupteur du moteur protectif de la pompe de prépression RO",
    KARCHER_INFO_MESSAGE_1:"La régénération de l'échangeur de base a commencé",
    KARCHER_INFO_MESSAGE_2:"La régénération de l'échangeur de base terminée",
    KARCHER_INFO_MESSAGE_3:"Echangeur de base épuisé à 75 %",
    KARCHER_INFO_MESSAGE_4:"Unité indisponible en raison d'un problème technique",
    KARCHER_INFO_MESSAGE_5:"Unité indisponible en raison d'un problème opérationnel",
    KARCHER_INFO_MESSAGE_6:"Unité en marche",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"La baie 1 est indisponible",
    KARCHER_INFO_MESSAGE_12:"La baie 2 est indisponible",
    KARCHER_INFO_MESSAGE_13:"La baie 3 est indisponible",
    KARCHER_INFO_MESSAGE_14:"La baie 4 est indisponible",
    KARCHER_INFO_MESSAGE_15:"La baie 5 est indisponible",
    KARCHER_INFO_MESSAGE_16:"La baie 6 est indisponible",
    KARCHER_INFO_MESSAGE_17:"La baie 7 est indisponible",
    KARCHER_INFO_MESSAGE_18:"La baie 8 est indisponible",
    KARCHER_INFO_MESSAGE_20:"Programme anti-légionelles pour réservoir d’eau chaude",
    KARCHER_INFO_MESSAGE_21:"Programme anti-légionelles pompe HP 1 requis",
    KARCHER_INFO_MESSAGE_22:"Programme anti-légionelles pompe HP 2 requis",
    KARCHER_INFO_MESSAGE_23:"Programme anti-légionelles pompe HP 3 requis",
    KARCHER_INFO_MESSAGE_24:"Programme anti-légionelles pompe HP 4 requis",
    KARCHER_INFO_MESSAGE_25:"Programme anti-légionelles pompe HP 5 requis",
    KARCHER_INFO_MESSAGE_26:"Programme anti-légionelles pompe HP 6 requis",
    KARCHER_INFO_MESSAGE_27:"Programme anti-légionelles pompe HP 7 requis",
    KARCHER_INFO_MESSAGE_28:"Programme anti-légionelles pompe HP 8 requis",
    KARCHER_INFO_MESSAGE_29:"Programme anti-légionelles terminé",
    KARCHER_INFO_MESSAGE_101:"La pompe haute pression 1 doit être révisée",
    KARCHER_INFO_MESSAGE_102:"La pompe haute pression 2 doit être révisée",
    KARCHER_INFO_MESSAGE_103:"La pompe haute pression 3 doit être révisée",
    KARCHER_INFO_MESSAGE_104:"La pompe haute pression 4 doit être révisée",
    KARCHER_INFO_MESSAGE_105:"La pompe haute pression 5 doit être révisée",
    KARCHER_INFO_MESSAGE_106:"La pompe haute pression 6 doit être révisée",
    KARCHER_INFO_MESSAGE_107:"La pompe haute pression 7 doit être révisée",
    KARCHER_INFO_MESSAGE_108:"La pompe haute pression 8 doit être révisée",
    KARCHER_INFO_MESSAGE_109:"Le brûleur doit être révisé",
    KARCHER_INFO_MESSAGE_110:"Ventilateur du brûleur doit être révisé",
    KARCHER_INFO_MESSAGE_111:"La pompe d'eau chaude doit être révisée",
    KARCHER_INFO_MESSAGE_112:"La pompe d'antigel doit être révisée",
    KARCHER_INFO_MESSAGE_113:"La pompe d'osmose doit être révisée",
    KARCHER_INFO_MESSAGE_114:"Pompe de chauffage au sol doit être révisée",
    KARCHER_INFO_MESSAGE_115:"Chauffage des tuyaux doit être révisé",
    KARCHER_INFO_MESSAGE_116:"Pompe de microémulsion / d'agent de nettoyage des jantes doit être révisée",
    KARCHER_INFO_MESSAGE_117:"Pompe de nettoyage du châssis doit être révisée",
    KARCHER_INFO_MESSAGE_118:"Pompe de pression du système doit être révisée",
    KARCHER_INFO_MESSAGE_119:"L'aspirateur 1 doit être révisée",
    KARCHER_INFO_MESSAGE_120:"L'aspirateur 2 doit être révisée",
    KARCHER_INFO_MESSAGE_121:"L'aspirateur 3 doit être révisée",
    KARCHER_INFO_MESSAGE_122:"L'aspirateur 4 doit être révisée",
    KARCHER_INFO_MESSAGE_123:"L'aspirateur 5 doit être révisée",
    KARCHER_INFO_MESSAGE_124:"L'aspirateur 6 doit être révisée",
    KARCHER_INFO_MESSAGE_125:"L'aspirateur 7 doit être révisée",
    KARCHER_INFO_MESSAGE_126:"L'aspirateur 8 doit être révisée",
    KARCHER_INFO_MESSAGE_127:"L'aspirateur 9 doit être révisée",
    KARCHER_INFO_MESSAGE_128:"L'aspirateur 10 doit être révisée",
    KARCHER_INFO_MESSAGE_129:"L'aspirateur 11 doit être révisée",
    KARCHER_INFO_MESSAGE_130:"L'aspirateur 12 doit être révisée",
    KARCHER_INFO_MESSAGE_131:"Pompe d'agent de nettoyage des jantes doit être révisée",
    KARCHER_INFO_MESSAGE_132:"Pompe de microémulsion doit être révisée",
    KARCHER_INFO_MESSAGE_133:"Pompe à mousse intensive doit être révisée",
    KARCHER_INFO_MESSAGE_142:"La turbine de l'aspirateur 1 doit être révisée",
    KARCHER_INFO_MESSAGE_143:"Le filtre de l'aspirateur 1 doit être révisé",
    KARCHER_INFO_MESSAGE_144:"La turbine de l'aspirateur 2 doit être révisée",
    KARCHER_INFO_MESSAGE_145:"Le filtre de l'aspirateur 2 doit être révisé",
    KARCHER_INFO_MESSAGE_146:"La turbine de l'aspirateur 3 doit être révisée",
    KARCHER_INFO_MESSAGE_147:"Le filtre de l'aspirateur 3 doit être révisé",
    KARCHER_INFO_MESSAGE_148:"La turbine de l'aspirateur 4 doit être révisée",
    KARCHER_INFO_MESSAGE_149:"Le filtre de l'aspirateur 4 doit être révisé",
    KARCHER_INFO_MESSAGE_150:"La turbine de l'aspirateur 5 doit être révisée",
    KARCHER_INFO_MESSAGE_151:"Le filtre de l'aspirateur 5 doit être révisé",
    KARCHER_INFO_MESSAGE_152:"La turbine de l'aspirateur 6 doit être révisée",
    KARCHER_INFO_MESSAGE_153:"Le filtre de l'aspirateur 6 doit être révisé",
    KARCHER_INFO_MESSAGE_154:"La turbine de l'aspirateur 7 doit être révisée",
    KARCHER_INFO_MESSAGE_155:"Le filtre de l'aspirateur 7 doit être révisé",
    KARCHER_INFO_MESSAGE_156:"La turbine de l'aspirateur 8 doit être révisée",
    KARCHER_INFO_MESSAGE_157:"Le filtre de l'aspirateur 8 doit être révisé",
    KARCHER_INFO_MESSAGE_158:"La turbine de l'aspirateur 9 doit être révisée",
    KARCHER_INFO_MESSAGE_159:"Le filtre de l'aspirateur 9 doit être révisé",
    KARCHER_INFO_MESSAGE_160:"La turbine de l'aspirateur 10 doit être révisée",
    KARCHER_INFO_MESSAGE_161:"Le filtre de l'aspirateur 10 doit être révisé",
    KARCHER_INFO_MESSAGE_162:"La turbine de l'aspirateur 11 doit être révisée",
    KARCHER_INFO_MESSAGE_163:"Le filtre de l'aspirateur 11 doit être révisé",
    KARCHER_INFO_MESSAGE_164:"La turbine de l'aspirateur 12 doit être révisée",
    KARCHER_INFO_MESSAGE_165:"Le filtre de l'aspirateur 12 doit être révisé",
    ORGANIZATION:"Organisation",
    CREATE_ORGANIZATION:"Créer l'organisation",
    CREATE_ORGANIZATION_AS:"Créer l'organisation en tant que filiale de",
    DELETE_ORGANIZATION:"Supprimer l'organisation",
    EDIT_ORGANIZATION:"Modifier l'organisation",
    SUPPORTED_ORG_NAME:"Organisation soutenue",
    SUPPORTED_ORG_TYPE:"Type d'organisation soutenue",
    ORG_NAME:"Nom",
    ORG_TYPE:"Type",
    SET_ORG_TITLE:"Créer la filiale",
    SET_SUPPORTED_ORG_TITLE:"Créer la filiale soutenue",
    SAVE_ORGANIZATION:"Sauvegarder l'organisation",
    SELECT_ORGANIZATION_TYPE:"Sélectionner le type d'organisation",
    SELECT_ORGANIZATION_SELECTOR:"Sélectionner",
    SELECT_SUPPORTED_ORGANIZATION:"Sélectionner l'organisation soutenue",
    ORGANIZATION_DELETED:"L'organisation a été supprimée.",
    ORGANIZATION_SAVED:"L'organisation a été sauvegardée.",
    ORGANIZATION_UPDATED:"L'organisation a été mise à jour.",
    ALERTS:"Alertes",
    DEVICE_STATUS:"Statut de l'appareil",
    SITE_DETAILS:"Détails du site",
    ALARM_STATUS:"Statut de l'alerte",
    FILTER:"Filtrer par...",
    FILTER_BY_ALERT_CENTER:"Filtrer par code, nom ou description",
    TOTAL_ALARM:"Total",
    LOW_ALARM:"Événement",
    MEDIUM_ALARM:"Défaillance",
    HIGH_ALARM:"Erreur critique",
    NO_FACILITIES_NEARBY:"Il n'y a aucune station de lavage à proximité.",
    GRAY_MAP:"Carte en gris",
    READY:"Prêt",
    WARNING:"Défaillance",
    ERROR:"Erreur",
    SITE_NAME:"Nom du site",
    ACCOUNTS_INFO:"Info du compte",
    USER_ORGANIZATION:"Organisation utilisateur",
    ADD_USER_ORGANIZATION:"Ajouter un nouvel utilisateur de l'organisation",
    EDIT_USER_ORGANIZATION:"Modifier les utilisateurs de l'organisation",
    SELECT_ROLE:"Sélectionner le rôle",
    SELECT_ORGANIZATION:"Sélectionner l'organisation",
    SELECT_USER:"Sélectionner l'utilisateur ",
    USER_FOR_ORGANIZATION_CREATED:"Un nouvel utilisateur a été créé. ",
    SELECT_REGION:"Sélectionner la région",
    SELECT_LANGUAGE:"Sélectionner la langue",
    LOADING_DATA:"Chargement des données, veuillez patienter...",
    ADMINISTRATOR:" Administrateur",
    TECHNICAL_SUPPORT:"Assistance technique",
    CONTROLLER:"Contrôleur",
    EDIT_ORGANIZATION_USER:"Modifier les utilisateurs de l'organisation",
    DELETE_ORGANIZATION_USER:"Supprimer les utilisateurs de l'organisation",
    USER_UPDATED:"L'utilisateur a été mis à jour.",
    USER_CREATED:"L'utilisateur a été créé.",
    ADDRESS:"Adresse",
    SUBSCRIPTIONS:"Abonnements",
    RESOLVED_STATUS:"Résolu",
    NOT_RESOLVED_STATUS:"Non résolu",
    ALERT_NAME:"Nom de l'alerte",
    ALERT_DESCRIPTION:"Description de l'alerte",
    ALERT_CODE:"Code de l'alerte",
    ALERT_TYPE:"Type d'alerte",
    UNSUBSCRIBE:"Se désabonner de l'alerte",
    SUBSCRIBE:"S'abonner à l'alerte",
    ALARM_SUBSCRIBED:"Vous êtes maintenant abonné(e).",
    UNSUBSCRIBED_CONFIRM:"Se désabonner?",
    ALARM_UNSUBSCRIBED:"Vous n'êtes plus abonné(e).",
    ASIDE_MENU_CASHLESS_SALES:"Transactions dématérialisées",
    FILTERED_CASHLESS_PAYMENTS:"Paiements dématérialisés filtrés",
    REFUND_DIALOG_TITLE:"Rembourser la transaction ?",
    REFUND_DIALOG_SUBTITLE:"Le montant peut être inférieur ou égal à celui de la transaction.",
    REFUND:"Rembourser",
    INPUT_NOT_VALID:"La saisie est invalide.",
    REFUND_SUCCESSFULLY:"Le remboursement du paiement sélectionné a été effectué.",
    USER:"Utilisateur",
    TRANSACTION_ID:"Référence PSP",
    DEVICE_ID:"ID de l'appareil",
    NET_AMOUNT:"Montant net",
    REPORT_NAME:"Nom du rapport",
    TIME_FRAME:"Période",
    SUB_POINT:"Sélectionner point de remplacement",
    SUB_POINT_LIST_NOT_EXIST:"Aucune liste de point de remplacement n'existe pour la station de lavage sélectionnée.",
    FACILITY_TYPE:"Type de station de lavage",
    MACHINE_NAME:"Nom de la machine",
    WASH_FACILITY_DETAILS:"Détails de la station de lavage",
    WASH_BAY_DETAILS:"Détails de la piste de lavage",
    DEVICES_INFO:"Liste des apaprailes",
    OPERATION_TIME_INFO:"Durée de fonctionnement",
    OPERATION_TIME_VACUUM_INFO:"Durée de fonctionnement des aspirateurs",
    OPERATION_TIME_ILLUMINATION_INFO:"Durée de fonctionnement de l'illumination",
    AVAILABLE_TITLE:"Disponible",
    UNAVAILABLE_TITLE:"Non disponible",
    CURRENT_PROGRAM:"Programme actuel",
    CREDITS:"Crédits",
    DEVICE_NAME:"Nom de l'appareil",
    ACTIVE_ALARMS:"Alertes actives",
    ALL_DAY:"Toute la journée",
    OPERATING_TIME_WASH_FACILITY:"Système de lavage en self-service",
    OPERATING_TIME_VACUUMS:"Aspirateurs",
    OPERATING_TIME_ILLUMINATION:"Illumination",
    OPERATION_COUNTERS:"Compteurs d'exploitation",
    EDIT:"Modifier",
    WASHING_PROGRAMS:"Programmes de lavage",
    INFO:"Événement",
    STATISTIC:"Statistique",
    ROLLOVER_DOSING:"Dosage",
    ROLLOVER_SPEED:"Vitesses",
    ROLLOVER_RESETS:"Réinitialisation à distance du portique",
    ROLLOVER_RESETS_INFO:"La réinitialisation doit être conforme aux réglementations locales. Attention : avant la réinitialisation, s'assurer que le portique est vide.",
    RESET_ROLLOVER:"Réinitialiser le portique",
    OPEN_DOOR_ROLLOVER:"Ouvrir",
    ROLLOVER_OPEN_DOOR_INFO:"Ouvrir la porte du hall de lavage en faisant attention.",
    ROLLOVER_OPEN_DOOR:"Ouvrir la porte",
    APPLY_DOSING_CHANGES:"Appliquer les changements de dosage",
    APPLY_SPEED_CHANGES:"Appliquer les changements de vitesse",
    ACTUATION_SUCCESS:"La demande a été envoyée.",
    REMAINING_TIME:"Temps restant",
    OPEN_24H:"Ouvert 24 heures",
    CLOSE_24H:"Fermé 24 heures",
    VALIDATION_OPERATION_TIME:" Format incorrect, veuillez utiliser hh:mm.",
    ROLLOVER:"Portique",
    UPDATE_WASHING_PROGRAM:"Mettre à jour les programmes de lavage",
    UPDATE_ACTUATORS:"Mettre les opérateurs à jour",
    OPEN_ROLOVER_DOOR_TITLE:"Voulez-vous ouvrir la porte du portique ?",
    OPEN_ROLOVER_DOOR_CONTENT:"Êtes-vous sûr(e) de vouloir ouvrir la porte ?",
    RESET_ROLOVER_TITLE:"Voulez-vous réinitialiser le portique ?",
    RESET_ROLOVER_CONTENT:"Êtes-vous sûr(e) de vouloir réinitialiser le portique ?",
    G0:"{{brand === 'r2w' ? 'Piste de lavage/Baie 0' : 'Piste de lavage/Baie 1'}}",
    G1:"{{brand === 'r2w' ? 'Piste de lavage/Baie 1' : 'Piste de lavage/Baie 2'}}",
    G2:"{{brand === 'r2w' ? 'Piste de lavage/Baie 2' : 'Piste de lavage/Baie 3'}}",
    G3:"{{brand === 'r2w' ? 'Piste de lavage/Baie 3' : 'Piste de lavage/Baie 4'}}",
    G4:"{{brand === 'r2w' ? 'Piste de lavage/Baie 4' : 'Piste de lavage/Baie 5'}}",
    G5:"{{brand === 'r2w' ? 'Piste de lavage/Baie 5' : 'Piste de lavage/Baie 6'}}",
    G6:"{{brand === 'r2w' ? 'Piste de lavage/Baie 6' : 'Piste de lavage/Baie 7'}}",
    G7:"{{brand === 'r2w' ? 'Piste de lavage/Baie 7' : 'Piste de lavage/Baie 8'}}",
    G8:"{{brand === 'r2w' ? 'Piste de lavage/Baie 8' : 'Piste de lavage/Baie 9'}}",
    G9:"{{brand === 'r2w' ? 'Piste de lavage/Baie 9' : 'Piste de lavage/Baie 10'}}",
    G10:"{{brand === 'r2w' ? 'Piste de lavage/Baie 10' : 'Piste de lavage/Baie 11'}}",
    U0:"{{brand === 'r2w' ? 'Aspirateur 0' : 'Aspirateur 1'}}",
    U1:"{{brand === 'r2w' ? 'Aspirateur 1' : 'Aspirateur 2'}}",
    U2:"{{brand === 'r2w' ? 'Aspirateur 2' : 'Aspirateur 3'}}",
    U3:"{{brand === 'r2w' ? 'Aspirateur 3' : 'Aspirateur 4'}}",
    U4:"{{brand === 'r2w' ? 'Aspirateur 4' : 'Aspirateur 5'}}",
    U5:"{{brand === 'r2w' ? 'Aspirateur 5' : 'Aspirateur 6'}}",
    U6:"{{brand === 'r2w' ? 'Aspirateur 6' : 'Aspirateur 7'}}",
    U7:"{{brand === 'r2w' ? 'Aspirateur 7' : 'Aspirateur 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Rapport du centre d'alerte créé par le site sélectionné depuis le tableau de bord.",
    ALERT_CENTER_TITLE_BY_FACILITY:"Rapport du centre d'alerte créé par la station de lavage sélectionnée depuis le tableau de bord.",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Rapport du centre d'alerte",
    ERROR_MESSAGE_403:"Vous n'avez pas le droit d'utiliser cet appel api. Code d'erreur : 403",
    LAST_ACTIVE_PROGRAM:"Programme actif/dernier programme actif",
    PROGRAM_ID:"Numéro de programme",
    PROGRAM_PRICE:"Prix du programme",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Recharge requise",
    EMPTY_CHEMICAL_LEVEL:"Vide",
    CHEMICAL_LEVEL:"Indication du niveau de détergents (%)",
    ROLLOVER_STATUS:" Statut du portique",
    ROLLOVER_STATUS_CODE_0:"Lavage actuellement en panne",
    ROLLOVER_STATUS_CODE_1:"Durée de fonctionnement extérieure",
    ROLLOVER_STATUS_CODE_2:"Saisie du programme autorisée",
    ROLLOVER_STATUS_CODE_3:"Mettez votre véhicule en position.",
    ROLLOVER_STATUS_CODE_4:"Avancez votre véhicule.",
    ROLLOVER_STATUS_CODE_5:"Reculez votre véhicule.",
    ROLLOVER_STATUS_CODE_6:"Arrêtez votre véhicule.",
    ROLLOVER_STATUS_CODE_7:"Lavage actif",
    ROLLOVER_STATUS_CODE_8:"Lavage arrêté",
    ROLLOVER_STATUS_CODE_9:"Lavage actif (tact)",
    ROLLOVER_STATUS_CODE_10:"Faites sortir votre véhicule en marche arrière",
    ROLLOVER_STATUS_CODE_11:"Arrêt d'urgence",
    ROLLOVER_STATUS_CODE_12:"Faites sortir votre véhicule en marche avant",
    ROLLOVER_STATUS_CODE_13:"Antigel actif",
    ROLLOVER_STATUS_CODE_14:"Interrupteur de sécurité avant activé",
    ROLLOVER_STATUS_CODE_15:"Interrupteur de sécurité arrière activé",
    ROLLOVER_STATUS_CODE_16:"Interrupteur de sécurité avant gauche activé",
    ROLLOVER_STATUS_CODE_17:"Interrupteur de sécurité avant droit activé",
    ROLLOVER_STATUS_CODE_18:"Interrupteur de sécurité arrière gauche activé",
    ROLLOVER_STATUS_CODE_19:"Interrupteur de sécurité arrière droit activé",
    ROLLOVER_STATUS_CODE_20:"Le véhicule est trop loin à gauche.",
    ROLLOVER_STATUS_CODE_21:"Le véhicule est trop loin à droite.",
    ROLLOVER_STATUS_CODE_22:"Portière gauche ouverte",
    ROLLOVER_STATUS_CODE_23:"Portière droite ouverte",
    ROLLOVER_STATUS_CODE_24:"Transporter détecté, mauvais programme de lavage sélectionné.",
    ROLLOVER_STATUS_CODE_25:"Détecteur de klaxon",
    ROLLOVER_STATUS_CODE_98:"Mode manuel/d'ajustement",
    ROLLOVER_STATUS_CODE_99:"Statut inconnu",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Code de statut non défini",
    ALARM:"Erreur critique",
    NO_ALARM:"Pas d'erreur critique",
    SOFTWARE_VERSION:" Version du logiciel",
    SOFTWARE_DATE:" Date du logiciel",
    SITE_ADDRESS:"Adresse du site",
    SECONDS:"Secondes",
    SERVICE_PART_NAME:"Nom du service :",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Compteur d'exploitation et d'entretien",
    OPERATION_COUNTER:"Compteur d'exploitation",
    SERVICE_COUNTER:"Compteur d'entretien",
    FAULT_CODE:"Code d'alerte",
    PRESSURE_TITLE:"Pression de l'air",
    TIME_TITLE:"Heure actuelle",
    COUNTRY_TITLE:"Pays",
    CITY_TITLE:"Ville",
    REGION_TITLE:"Région",
    SELECT_POINTS_TO_SEARCH:"Sélectionnez les points...",
    LOGS_HISTORY:"Historique des changements de paramètres ",
    ACTUATOR_REFERENCE:"Référence de l'opérateur",
    ACTUATOR_VALUE:"Valeur de l'opérateur",
    POINT_ID:"ID du point",
    VALIDATION_NOT_VALID_RANGE:"Gamme incorrecte",
    ENABLE_ROLLOVER_RESET:"En cochant cette case, vous confirmez avoir lu et accepté les instructions de sécurité.",
    CHANGE_OF_PARAMETERS:"Changement de paramètres",
    SELECT_OPTIONS:"Sélectionner les options",
    AUTOMATIC:"Automatique",
    DESALTING:"Fonction de dessalage",
    SEASON_WASH:"Programmes de lavage saisonniers",
    SPRING_PROGRAM:"Programmes de lavage de printemps",
    SUMMER_PROGRAM:"Programmes de lavage d'été",
    AUTUMN_PROGRAM:"Programmes de lavage d'automne",
    WINTER_PROGRAM:"Programmes de lavage d'hiver",
    DOOR_CONTROL:"Contrôle de la porte",
    SUMMER_DOOR_CONTROL:"Été, contrôle de la porte en mode été",
    WINTER_DOOR_CONTROL:"Hiver, contrôle de la porte en mode hiver",
    APPLY_PARAMETERS_CHANGES:"Appliquer les changements de paramètres",
    WORKING_SCHEDULES:"Heures de travail",
    HOLIDAY_SCHEDULES:"Horaires de vacances",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Les jours fériés ont été créés pour ce site.",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Les jours fériés ont été mis à jour pour ce site.",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Les jours fériés ont été supprimés pour ce site.",
	WORKING_SCHEDULES_SUCCESSFULLY_UPDATED:"Les horaires de travail ont été mis à jour avec succès",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Les heures de travail sont propagées.",
    HOLIDAY_SUCCESSFULLY_DELETED:"Les jours fériés ont été supprimés.",
    SB_MU_MB_2_2_0:" SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:" SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:" SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:" SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:" SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:" SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:" SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:" SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:" SB_OB_2_0_0_Trans",
    CB3_1_0_0:" CB3_1_0_0_Trans",
    CW35_3_0_0:" CW35_3_0_0_Trans",
    CW35_3_1_0:" CW35_3_1_0_Trans",
    CWB3_3_0_0:" CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:" CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Agent séchant à faible niveau de remplissage",
    CHEM_LEVEL_LOW_SHAMPOO:"Shampoing à faible niveau de remplissage",
    CHEM_LEVEL_LOW_FOAM:"Mousse à faible niveau de remplissage",
    CHEM_LEVEL_LOW_WAX_1:"Cire à faible niveau de remplissage",
    CHEM_LEVEL_LOW_POLISH_1:"Agent lustrant à faible niveau de remplissage",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Nettoyant pour jantes à faible niveau de remplissage",
    CHEM_LEVEL_LOW_WAX_2:"Cire à faible niveau de remplissage",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Lustrant pour roues à faible niveau de remplissage",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Nettoyant insectes à faible niveau de remplissage",
    CHEM_LEVEL_LOW_POLISH_2:"Agent lustrant à faible niveau de remplissage",
    CHEM_LEVEL_LOW_INTENSIVE:"Détergent intense à faible niveau de remplissage",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Pluie de mousse à faible niveau de remplissage",
    CHEM_LEVEL_DRYING_AGENT:"Niveau de remplissage de l'agent de séchage",
    CHEM_LEVEL_SHAMPOO:"Niveau de remplissage du shampoing",
    CHEM_LEVEL_FOAM:"Niveau de remplissage de la mousse",
    CHEM_LEVEL_WAX_1:"Niveau de remplissage de la cire",
    CHEM_LEVEL_POLISH_1:"Niveau de remplissage de l'agent lustrant",
    CHEM_LEVEL_RIM_CLEANER:"Niveau de remplissage du nettoyant pour jantes",
    CHEM_LEVEL_WAX_2:"Niveau de remplissage de la cire",
    CHEM_LEVEL_TYRE_SHINE:"Niveau de remplissage du lustrant pour roues",
    CHEM_LEVEL_INSECT_REMOVER:"Niveau de remplissage du nettoyant insectes",
    CHEM_LEVEL_POLISH_2:"Niveau de remplissage de l'agent lustrant",
    CHEM_LEVEL_INTENSIVE:"Niveau de remplissage du détergent intense",
    CHEM_LEVEL_FOAM_RAIN:"Niveau de remplissage de la pluie de mousse",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Compteur d'entretien courroie de levage du rouleau de toit",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Compteur d'entretien courroie de levage du sécheur",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Compteur d'entretien brosse de toit du câble moteur",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Compteur d'entretien entretien de la pompe eau douce",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Compteur d'entretien entretien de la pompe eau usagée",
    DRYING_AGENT:"Agent de séchage",
    FOAM_DRYING_AGENT:"Agent de séchage mousse",
    SHAMPOO:"Shampoing",
    FOAM:"Mousse",
    BRUSH_FOAM:"Mousse brosse",
    WAX_1:"Cire",
    FOAM_WAX_1:"Cire mousse",
    POLISH_1:"Agent lustrant",
    RIM_CLEANING:"Nettoyant pour jantes",
    WAX_2:"Cire",
    FOAM_WAX_2:"Cire mousse",
    TYRE_SHINE:"Lustrant pour roues",
    INSECT_REMOVER:"Nettoyant insectes",
    POLISH_2:"Agent lustrant",
    INTENSIVE_BASIC:"Lavage intensif basique",
    INTENSIVE_SIDE:"Lavage intensif côté",
    INTENSIVE_ROOF_SPRAY_BAR:"Lavage intensif barre de pulvérisation toit",
    TAR_REMOVER:"Dégoudronnant",
    UNDER_CHASSIS_CONVERSATION:" Conversation sous le châssis",
    STATIONARY_PRE_SPRAY_ARCH:"Portique stationnaire prépulvérisation",
    FOAM_RAIN:"Pluie de mousse",
    PRE_CLEANING:"Prénettoyage",
    BRUSH:"Brosse",
    CARE:"Soin",
    DRYING:"Séchage",
    DRYING_LOW_NOISE:"Séchage moins bruyant",
    INTENSIVE_CLEANING:"Nettoyage intense",
    BRUSH_CLEANING:"Nettoyage à la brosse",
    EMPTY_RUN:"Fonctionnement à vide",
    DRYING_AID:"Accélérateur de séchage",
    WAX:"Cire",
    FOAM_WASH:"Lavage mousse",
    POLISH:"Agent lustrant",
    FOAM_POLISH:"Agent lustrant mousse",
    WHEEL_CLEANING:"Nettoyage des roues",
    HIGH_PRESSURE_ROOF:"Haute pression toit",
    HIGH_PRESSURE_SIDE:"Haute pression côté",
    DRYER_FORWARD:"Sécheur avant",
    DRYER_BACKWARD:"Sécheur arrière",
    DELETE_ALL_HOLIDAYS:"Supprimer tous les jours fériés pour ce site",
    CREATE_NEW_HOLIDAY:"Créer un nouveau jour férié",
    RESET_INPUTS:"Réinitialiser toutes les saisies de jour férié",
    TWENTY_FOUR_HOURS_OPEN:"Ouvert 24/24 h",
    EVERY_YEAR:"Annuellement",
    DELETE_HOLIDAY:"Supprimer le jour férié",
    ADD_NEW_HOLIDAY:"Ajouter un nouveau jour férié",
    HOLIDAYS_LIST:"Liste des jours fériés existants",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Supprimer tous les jours fériés pour ce site ?",
    VALIDATION_HOLIDAY_DATE:" Format incorrect, veuillez utiliser mm-jj.",
    FOR_DATE:"Pour la date",
    WITH_ID:"Avec ID",
    FROM_HOURS:"De (h)",
    FROM_MINUTES:"De (min)",
    TO_HOURS:"À (h)",
    TO_MINUTES:"À (min)",
    NOT_MATCH:"Ne correspond pas",
    START:"De",
    STOP:"À",
    DAILY_TIME:"Liste de 24 heures",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Réglage individuel de l'heure",
    PROGRAM_NOT_STARTED:"Le programme n'a pas encore commencé.",
    JETWASH:"Système de lavage en self-service",
    KARCHER_REPORT_1:"Portique : indication de la rotation par programme et au total",
    KARCHER_REPORT_2:"Portique : lavages commencés par programme et au total",
    KARCHER_REPORT_3:"Portique : lavages effectués par programme et au total",
    KARCHER_REPORT_4:"Portique : nombre de lavages commencés au moyen du terminal de paiement par programme et au total",
    KARCHER_REPORT_5:"Portique : nombre de lavages commencés manuellement par programme et au total",
    KARCHER_REPORT_6:"Portique : nombre de lavages annulés par programme et au total",
    KARCHER_REPORT_7:"Portique : nombre de défaillances de l'alimentation électrique",
    KARCHER_REPORT_8:"Unités SB : nombre d'heures par programme de lavage filtré par piste de lavage/baie et au total",
    KARCHER_REPORT_9:"Unités SB : indication de la rotation par piste de lavage/baie et au total",
    KARCHER_REPORT_10:"Unités SB : compteur de jetons/pièces par canal de pièce",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Pompe eau douce",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Pompe eau traitée",
    OPERATION_COUNTER_HP_PUMP_1:"Pompe haute pression 1",
    OPERATION_COUNTER_HP_PUMP_2:"Pompe haute pression 2",
    RELEASE_NOTES:" Versions de l'appli et notes de mise à jour",
    BACKEND_RELEASE_NOTES:"Notes de mise à jour de la plateforme :",
    FRONTEND_RELEASE_NOTES:"Notes de mise à jour de l'application web :",
    SELECTED_FACILITY_TIMEZONE:"Fuseau horaire de la station de lavage sélectionnée :",
    REFRESH_PAGE:"Rafraîchir la page",
    REFRESH_MAPS:"Rafraîchir les cartes",
    PUMPS:"Pompes",
    RUN_TIME:"Durée de fonctionnement",
    RUN_TIME1:"Durée de fonctionnement 1",
    RUN_TIME2:"Durée de fonctionnement 2",
    PROGRAM_RUNTIME_ACTUATOR:"Opérateur de la durée de fonctionnement",
    PROGRAM_RUNTIME_ACTUATOR_1:"Opérateur de la durée de fonctionnement 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Opérateur de la durée de fonctionnement 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"La valeur minimum est 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"La valeur maximum est 25",
    WASH_PROGRAM_MIN_MAX_VALIDATION:" Utiliser un format de prix x.xx",
    ACTUATION_NOT_ALLOWED:"L'activation n'est pas autorisée pour le rôle d'utilisateur actuel.",
    MAINTENANCE_DAYS:"Jours de maintenance",
    MAINTENANCE_WASHES:"Lavages de maintenance",
    DAILY_FINANCES_POS:"PDV",
    POS_INCOME:"Revenu total PDV",
    PROPAGATE:"Propager",
    ALL_DAY_HOURS_SELECTOR:"Sélecteur type 24 heures",
    GET_OPERATING_TIME_FROM_SITE:"Obtenir la durée de fonctionnement de l'appareil actuel depuis les heures de travail du site.",
    USER_NOT_VALID:"L'utilisateur n'est pas valide. Essayez avec un autre identifiant de compte.",
    VERIFIED:"Vérifié",
    RESEND_VERIFICATION_MAIL:"Envoyer un nouvel e-mail de vérification",
    RETURN_TO_DASHBOARD:"Retour au tableau de bord",
    ERROR_PAGE_BAD_REQUEST:" 400 requête non valide",
    WASHES:"Nombre de lavages",
    TIME_TO_SERVICE:"Entretien requis",
    ACCOUNT_ALREADY_ACTIVATED:"Compte déjà activé",
    DEVICE_EVENTS:"Événements de l'appareil",
    DEVICE_EVENTS_LOG_PULLED:"Journal des événements récupérés pour l'appareil",
    EVENTS_PULL_DATE:"Heure des événements récupérés :",
    DEVICE_EVENTS_REFRESH:"Récupérer de nouvelles données d'événements",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Problème de connexion des Web sockets. Essayez de rafraîchir la page.",
    INSTALLATION_DATE:"Date d'installation de la machine",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Cire chaude",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Lavage haute pression",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Mousse de jante puissante",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Mousse puissante",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Arrêter",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Lavage à mousse HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Lavage",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Soins de haut niveau",
    INFO_TITLE:"Info",
    FOAM_WAX1:"Cire mousse",
    POLISH1:"Agent lustrant",
    WAX1:"Cire",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Détails du site mis à jour avec succès",
    COMPANY:"Société",
    FACILITY_HAS_CHANGER:"Avez-vous un changeur ?",
    DISABLE_OFFLINE_ALARM:"Désactiver les alarmes R2W",
    ASIDE_WORKING_SCHEDULES:"Détails du site de l'application",
    TERMS_OF_SERVICE_R2W_TITLE:"Conditions de service de Ready2Wash",
    TERMS_OF_SERVICE_R2W:"Conditions de service de Ready2Wash",
    DATA_PROCESSING_TITLE:"Données traitées",
    PRIVACY_POLICY_TITLE:"Politique de confidentialité",
    READY_TO_PAY_TERMS_OF_SERVICE:"Conditions de service de Ready2Pay",
    TERMS_AND_SERVICES:"Termes et services",
    HOURLY: "Toutes les heures",
    DAILY: "Quotidien",
    WEEKLY: "Hebdomadaire",
    MONTHLY: "Mensuel",
    YEARLY: "Annuel",
    DELETE_ITEM_SUCCESS:"Vous avez supprimé l'élément avec succès",
    STATE: "État",
    AVAILABILITY_STATUS_1: "Unité ouverte",
    AVAILABILITY_STATUS_2: "Unité fermée (vacances)",
    AVAILABILITY_STATUS_3: "Unité fermée (heures d'ouverture)",
    AVAILABILITY_STATUS_4: "Unité fermée (panne)",
    AVAILABILITY_STATUS_5: "Unité fermée (autre)",
    AVAILABILITY_VACUUMS_STATUS_1: "Aspirateurs non installés",
    AVAILABILITY_VACUUMS_STATUS_2: "Aspirateurs ouverts",
    AVAILABILITY_VACUUMS_STATUS_3: "Aspirateurs fermés (vacances)",
    AVAILABILITY_VACUUMS_STATUS_4: "Aspirateurs fermés (heures d'ouverture)",
    AVAILABILITY_VACUUMS_STATUS_5: "Aspirateurs fermés (panne)",
    AVAILABILITY_VACUUMS_STATUS_6: "Aspirateurs fermés (autre)",
    ECOM_AMOUNT: "Total Ecom pour tous les sites",
    CAPTURED: "Capturé",
    DELETE_COMPANY_HISTORY_INFO:"Cette action supprimera toutes les données de rapport de votre entreprise. Cette action est irréversible.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Êtes-vous sûr de vouloir supprimer définitivement toutes les données de rapport ?",
    VALUE_DATE: "Date de valeur",
    KARCHER_EVENT_NAME_1: "Échangeur de base régénéré",
    KARCHER_EVENT_NAME_2: "Régénération de l'échangeur de base terminée",
    KARCHER_EVENT_NAME_3: "Matériel / numéro de série",
    KARCHER_EVENT_NAME_4: "Le système a été désinfecté",
    KARCHER_EVENT_NAME_5: "Pompe HP 1 désinfectée",
    KARCHER_EVENT_NAME_6: "Pompe HP 2 désinfectée",
    KARCHER_EVENT_NAME_7: "Pompe HP 3 désinfectée",
    KARCHER_EVENT_NAME_8: "Pompe HP 4 désinfectée",
    KARCHER_EVENT_NAME_9: "Pompe HP 5 désinfectée",
    KARCHER_EVENT_NAME_10: "Station de lavage 1 verrouillée",
    KARCHER_EVENT_NAME_11: "Station de lavage 2 verrouillée",
    KARCHER_EVENT_NAME_12: "Station de lavage 3 verrouillée",
    KARCHER_EVENT_NAME_13: "Station de lavage 4 verrouillée",
    KARCHER_EVENT_NAME_14: "Station de lavage 5 verrouillée",
    KARCHER_EVENT_NAME_15: "Station de lavage 6 verrouillée",
    KARCHER_EVENT_NAME_16: "Station de lavage 7 verrouillée",
    KARCHER_EVENT_NAME_17: "Station de lavage 8 verrouillée",
    KARCHER_EVENT_NAME_18: "Mise à jour démarrée",
    KARCHER_EVENT_NAME_19: "Mise à jour terminée",
    KARCHER_EVENT_NAME_20: "Démarrage WS Reg",
    KARCHER_EVENT_NAME_21: "Fin WS Reg",
    KARCHER_EVENT_NAME_22: "Capteur WS 75%",
    KARCHER_EVENT_NAME_23: "Défaut technique",
    KARCHER_EVENT_NAME_24: "Défaut de fonctionnement",
    KARCHER_EVENT_NAME_25: "Unité activée",
    KARCHER_EVENT_NAME_26: "Unité désactivée",
    KARCHER_EVENT_NAME_27: "Boîte 1 fermée",
    KARCHER_EVENT_NAME_28: "Boîte 2 fermée",
    KARCHER_EVENT_NAME_29: "Boîte 3 fermée",
    KARCHER_EVENT_NAME_30: "Boîte 4 fermée",
    KARCHER_EVENT_NAME_31: "Boîte 5 fermée",
    KARCHER_EVENT_NAME_32: "Boîte 6 fermée",
    KARCHER_EVENT_NAME_33: "Boîte 7 fermée",
    KARCHER_EVENT_NAME_34: "Boîte 8 fermée",
    KARCHER_EVENT_NAME_35: "Station des pompes HP 1",
    KARCHER_EVENT_NAME_36: "Station des pompes HP 2",
    KARCHER_EVENT_NAME_37: "Station des pompes HP 3",
    KARCHER_EVENT_NAME_38: "Station des pompes HP 4",
    KARCHER_EVENT_NAME_39: "Station des pompes HP 5",
    KARCHER_EVENT_NAME_40: "Station des pompes HP 6",
    KARCHER_EVENT_NAME_41: "Station des pompes HP 7",
    KARCHER_EVENT_NAME_42: "Station des pompes HP 8",
    KARCHER_EVENT_NAME_43: "Brûleur",
    KARCHER_EVENT_NAME_44: "Ventilateur du brûleur",
    KARCHER_EVENT_NAME_45: "Pompe à eau chaude",
    KARCHER_EVENT_NAME_46: "Pompe antigel",
    KARCHER_EVENT_NAME_47: "Pompe à osmose",
    KARCHER_EVENT_NAME_48: "Chauffage par le sol",
    KARCHER_EVENT_NAME_49: "Chauffage du tuyau",
    KARCHER_EVENT_NAME_50: "Nettoyage micro / jantes",
    KARCHER_EVENT_NAME_51: "Pompe de lavage sous-châssis",
    KARCHER_EVENT_NAME_52: "Pompe booster mousse",
    KARCHER_EVENT_NAME_53: "Aspirateur 1",
    KARCHER_EVENT_NAME_54: "Aspirateur 2",
    KARCHER_EVENT_NAME_55: "Aspirateur 3",
    KARCHER_EVENT_NAME_56: "Aspirateur 4",
    KARCHER_EVENT_NAME_57: "Aspirateur 5",
    KARCHER_EVENT_NAME_58: "Aspirateur 6",
    KARCHER_EVENT_NAME_59: "Aspirateur 7",
    KARCHER_EVENT_NAME_60: "Aspirateur 8",
    KARCHER_EVENT_NAME_61: "Aspirateur 9",
    KARCHER_EVENT_NAME_62: "Aspirateur 10",
    KARCHER_EVENT_NAME_63: "Aspirateur 11",
    KARCHER_EVENT_NAME_64: "Aspirateur 12",
    KARCHER_EVENT_NAME_65: "Pompe de nettoyage des jantes",
    KARCHER_EVENT_NAME_66: "Pompe Microe.",
    KARCHER_EVENT_NAME_67: "Pompe intensive",
    KARCHER_EVENT_NAME_68: "Turbine de l'aspirateur 1",
    KARCHER_EVENT_NAME_69: "Filtre de l'aspirateur 1",
    KARCHER_EVENT_NAME_70: "Turbine de l'aspirateur 2",
    KARCHER_EVENT_NAME_71: "Filtre de l'aspirateur 2",
    KARCHER_EVENT_NAME_72: "Turbine de l'aspirateur 3",
    KARCHER_EVENT_NAME_73: "Filtre de l'aspirateur 3",
    KARCHER_EVENT_NAME_74: "Turbine de l'aspirateur 4",
    KARCHER_EVENT_NAME_75: "Filtre de l'aspirateur 4",
    KARCHER_EVENT_NAME_76: "Turbine de l'aspirateur 5",
    KARCHER_EVENT_NAME_77: "Filtre de l'aspirateur 5",
    KARCHER_EVENT_NAME_78: "Turbine de l'aspirateur 6",
    KARCHER_EVENT_NAME_79: "Filtre de l'aspirateur 6",
    KARCHER_EVENT_NAME_80: "Turbine de l'aspirateur 7",
    KARCHER_EVENT_NAME_81: "Filtre de l'aspirateur 7",
    KARCHER_EVENT_NAME_82: "Turbine de l'aspirateur 8",
    KARCHER_EVENT_NAME_83: "Filtre de l'aspirateur 8",
    KARCHER_EVENT_NAME_84: "Turbine de l'aspirateur 9",
    KARCHER_EVENT_NAME_85: "Filtre de l'aspirateur 9",
    KARCHER_EVENT_NAME_86: "Turbine de l'aspirateur 10",
    KARCHER_EVENT_NAME_87: "Filtre de l'aspirateur 10",
    KARCHER_EVENT_NAME_88: "Turbine de l'aspirateur 11",
    KARCHER_EVENT_NAME_89: "Filtre de l'aspirateur 11",
    KARCHER_EVENT_NAME_90: "Turbine de l'aspirateur 12",
    KARCHER_EVENT_NAME_91: "Filtre de l'aspirateur 12",
    INSERT_TOKEN: "Insérez les jetons et démarrez le service",
    OPEN_SESSION: "Session ouverte avec succès",
    IN_PROGRESS: "En cours ...",
    TOKEN_INSERTED: "Jetons insérés avec succès",
    EXPIRED_SESSION: "Session expirée",
    TWO_DIGIT_INTEGER_VALIDATION: "Utilisez un entier de deux chiffres maximum",
    KARCHER_OPERATION_COUNTER_1: "Zone de lavage 1, pompe HP",
    KARCHER_OPERATION_COUNTER_2: "Zone de lavage 1, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_3: "Zone de lavage 1, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_4: "Zone de lavage 1, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_5: "Zone de lavage 1, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_6: "Zone de lavage 2, pompe HP",
    KARCHER_OPERATION_COUNTER_7: "Zone de lavage 2, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_8: "Zone de lavage 2, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_9: "Zone de lavage 2, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_10: "Zone de lavage 2, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_11: "Zone de lavage 3, pompe HP",
    KARCHER_OPERATION_COUNTER_12: "Zone de lavage 3, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_13: "Zone de lavage 3, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_14: "Zone de lavage 3, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_15: "Zone de lavage 3, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_16: "Zone de lavage 4, pompe HP",
    KARCHER_OPERATION_COUNTER_17: "Zone de lavage 4, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_18: "Zone de lavage 4, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_19: "Zone de lavage 4, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_20: "Zone de lavage 4, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_21: "Zone de lavage 5, pompe HP",
    KARCHER_OPERATION_COUNTER_22: "Zone de lavage 5, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_23: "Zone de lavage 5, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_24: "Zone de lavage 5, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_25: "Zone de lavage 5, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_26: "Zone de lavage 6, pompe HP",
    KARCHER_OPERATION_COUNTER_27: "Zone de lavage 6, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_28: "Zone de lavage 6, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_29: "Zone de lavage 6, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_30: "Zone de lavage 6, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_31: "Zone de lavage 7, pompe HP",
    KARCHER_OPERATION_COUNTER_32: "Zone de lavage 7, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_33: "Zone de lavage 7, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_34: "Zone de lavage 7, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_35: "Zone de lavage 7, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_36: "Zone de lavage 8, pompe HP",
    KARCHER_OPERATION_COUNTER_37: "Zone de lavage 8, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_38: "Zone de lavage 8, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_39: "Zone de lavage 8, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_40: "Zone de lavage 8, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_41: "Pompe à osmose",
    KARCHER_OPERATION_COUNTER_42: "Générateur d’eau chaude",
    KARCHER_OPERATION_COUNTER_43: "Pompe de protection antigel",
    KARCHER_OPERATION_COUNTER_44: "Insert de filtre WSO",
    KARCHER_OPERATION_COUNTER_45: "Pompe de chauffage de la piste de lavage",
    KARCHER_OPERATION_COUNTER_46: "Pompe à eau chaude",
    KARCHER_OPERATION_COUNTER_47: "Chauffage du flexible de mousse",
    KARCHER_OPERATION_COUNTER_48: "Pompe de nettoyage de jantes",
    KARCHER_OPERATION_COUNTER_49: "Pompe de micro-émulsion",
    KARCHER_OPERATION_COUNTER_50: "Pompe de mousse intensive",
    KARCHER_OPERATION_COUNTER_51: "Aspirateur 1, turbine 1",
    KARCHER_OPERATION_COUNTER_52: "Aspirateur 1, filtre 1",
    KARCHER_OPERATION_COUNTER_53: "Aspirateur 1, turbine 2",
    KARCHER_OPERATION_COUNTER_54: "Aspirateur 1, filtre 2",
    KARCHER_OPERATION_COUNTER_55: "Aspirateur 2, turbine 1",
    KARCHER_OPERATION_COUNTER_56: "Aspirateur 2, filtre 1",
    KARCHER_OPERATION_COUNTER_57: "Aspirateur 2, turbine 2",
    KARCHER_OPERATION_COUNTER_58: "Aspirateur 2, filtre 2",
    KARCHER_OPERATION_COUNTER_59: "Aspirateur 3, turbine 1",
    KARCHER_OPERATION_COUNTER_60: "Aspirateur 3, filtre 1",
    KARCHER_OPERATION_COUNTER_61: "Aspirateur 3, turbine 2",
    KARCHER_OPERATION_COUNTER_62: "Aspirateur 3, filtre 2",
    KARCHER_OPERATION_COUNTER_63: "Aspirateur 4, turbine 1",
    KARCHER_OPERATION_COUNTER_64: "Aspirateur 4, filtre 1",
    KARCHER_OPERATION_COUNTER_65: "Aspirateur 4, turbine 2",
    KARCHER_OPERATION_COUNTER_66: "Aspirateur 4, filtre 2",
    KARCHER_OPERATION_COUNTER_67: "Aspirateur 5, turbine 1",
    KARCHER_OPERATION_COUNTER_68: "Aspirateur 5, filtre 1",
    KARCHER_OPERATION_COUNTER_69: "Aspirateur 5, turbine 2",
    KARCHER_OPERATION_COUNTER_70: "Aspirateur 5, filtre 2",
    KARCHER_OPERATION_COUNTER_71: "Aspirateur 6, turbine 1",
    KARCHER_OPERATION_COUNTER_72: "Aspirateur 6, filtre 1",
    KARCHER_OPERATION_COUNTER_73: "Aspirateur 6, turbine 2",
    KARCHER_OPERATION_COUNTER_74: "Aspirateur 6, filtre 2",
    KARCHER_OPERATION_COUNTER_75: "Vider l’eau de condensation du compresseur",
    KARCHER_OPERATION_COUNTER_76: "Vérifier le système antigel",
    KARCHER_OPERATION_COUNTER_77: "Soufflerie du brûleur",
    KARCHER_OPERATION_COUNTER_78: "Augmentation de pression Mousse",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "La liste des données est supérieure à 10000 éléments",
    KARCHER_POINT_NAME_1: "Jour férié",
    KARCHER_POINT_NAME_2: "Lundi",
    KARCHER_POINT_NAME_3: "Mardi",
    KARCHER_POINT_NAME_4: "Mercredi",
    KARCHER_POINT_NAME_5: "Jeudi",
    KARCHER_POINT_NAME_6: "Vendredi",
    KARCHER_POINT_NAME_7: "Samedi",
    KARCHER_POINT_NAME_8: "Dimanche",
    KARCHER_POINT_NAME_9: "Aspirateurs Jour férié",
    KARCHER_POINT_NAME_10: "Aspirateurs Lundi",
    KARCHER_POINT_NAME_11: "Aspirateurs Mardi",
    KARCHER_POINT_NAME_12: "Aspirateurs Mercredi",
    KARCHER_POINT_NAME_13: "Aspirateurs Jeudi",
    KARCHER_POINT_NAME_14: "Aspirateurs Vendredi",
    KARCHER_POINT_NAME_15: "Aspirateurs Samedi",
    KARCHER_POINT_NAME_16: "Aspirateurs Dimanche",
    KARCHER_POINT_NAME_17: "Éclairage Jour férié",
    KARCHER_POINT_NAME_18: "Éclairage Lundi",
    KARCHER_POINT_NAME_19: "Éclairage Mardi",
    KARCHER_POINT_NAME_20: "Éclairage Mercredi",
    KARCHER_POINT_NAME_21: "Éclairage Jeudi",
    KARCHER_POINT_NAME_22: "Éclairage Vendredi",
    KARCHER_POINT_NAME_23: "Éclairage Samedi",
    KARCHER_POINT_NAME_24: "Éclairage Dimanche",
    KARCHER_POINT_NAME_25: "Programme 0",
    KARCHER_POINT_NAME_26: "Programme 1",
    KARCHER_POINT_NAME_27: "Programme 2",
    KARCHER_POINT_NAME_28: "Programme 3",
    KARCHER_POINT_NAME_29: "Programme 4",
    KARCHER_POINT_NAME_30: "Programme 5",
    KARCHER_POINT_NAME_31: "Programme 6",
    KARCHER_POINT_NAME_32: "Programme 7",
    KARCHER_POINT_NAME_33: "Programme 8",
    KARCHER_POINT_NAME_34: "Programme 9",
    KARCHER_POINT_NAME_35: "Programme 10",
    KARCHER_POINT_NAME_36: "Programme 11",
    KARCHER_POINT_NAME_37: "Programme 12",
    KARCHER_POINT_NAME_38: "Programme 13",
    KARCHER_POINT_NAME_39: "Programme 14",
    KARCHER_POINT_NAME_40: "Programme 15",
    KARCHER_POINT_NAME_41: "Programme 16",
    KARCHER_POINT_NAME_42: "Programme 17",
    KARCHER_POINT_NAME_43: "Programme 18",
    KARCHER_POINT_NAME_44: "Programme 19",
    KARCHER_POINT_NAME_45: "Programme 20",
    KARCHER_POINT_NAME_46: "Programme 21",
    KARCHER_POINT_NAME_47: "Programme 22",
    KARCHER_POINT_NAME_48: "Programme 23",
    KARCHER_POINT_NAME_49: "Programme 24",
    KARCHER_POINT_NAME_50: "Programme 25",
    KARCHER_POINT_NAME_51: "Programme 26",
    KARCHER_POINT_NAME_52: "Programme 27",
    KARCHER_POINT_NAME_53: "Programme 28",
    KARCHER_POINT_NAME_54: "Programme 29",
    KARCHER_POINT_NAME_55: "Programme 30",
    KARCHER_POINT_NAME_56: "Programme 31",
    KARCHER_POINT_NAME_57: "Programme 32",
    QR_CODE: "Code QR",
    ACCEPT_TERMS_AND_CONDITIONS: "Accepter les conditions générales",
    CREATE_AND_PRINT_VOUCHERS: "Créer et imprimer les coupons",
    CODE_PREFIX_QUESTION: "Le préfixe du code n'est pas saisi",
    CODE_PREFIX_QUESTION_TEXT: "Voulez-vous continuer sans préfixe de code ?",
    ISSUED_DATE: "Date d'émission",
    VOUCHER_VALIDITY_DAYS: "Validité du coupon (jours)",
    VALIDATION_ONLY_NUMBERS: "Seuls les chiffres sont autorisés",
    REPRINT_VOUCHERS: "Imprimer une copie des coupons",
    EXPIRY_DATE: "Valable jusqu'au",
    VOUCHER_TYPE_VACUUM: "Bon pour: Aspirateur",
    VOUCHER_TYPE_JETWASH: "Bon pour: Jet Wash Care",
    VOUCHER_TYPE_MATT: "Bon pour: Matt"
  });
})();
